import { motion } from 'framer-motion'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { FiAlertTriangle, FiSearch, FiTrash2 } from 'react-icons/fi'
import { MdArrowBackIosNew, MdArrowForwardIos, MdDelete } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import {
  ColumnsTable,
  ICostAndQuantity,
  ICreatePurchaseDTO,
  IDealer,
  IITemToPurchase,
  InventorySearch,
  IRotationForm,
  IWarehouse,
} from 'safe'
import ProviderAnimation from '../../../assets/animations/5081-empty-box.json'
import defaultImage from '../../../assets/images/img-placeholder.jpg'
import Empty from '../../../components/Display/Empty'
import Modal from '../../../components/Display/Modal'
import ModalInventorySearch from '../../../components/Display/ModalInventorySearch'
import Table from '../../../components/Display/Table'
import Button from '../../../components/General/Button'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../../hooks/useLocalStorageState'
import {
  createDealer,
  fetchDealers,
  updateDealer,
} from '../../../redux/actions/dealers'
import { RootState } from '../../../redux/store'
import ShowLocations from '../../operations/Transfers/ShowLocations'
// import LoadForm from './LoadForm'
import axios from 'axios'
import ModalConfirm from '../../../components/Display/ModalConfirm'
import {
  dateToDB,
  formatPipe,
  getDenomination,
  getISOtime,
  getItemType,
} from '../../../utils/utils'
import DealersForm from '../../Dealers/DealersForm'
import CostForm from '../../Inventory/CostForm'
import InventoryForm from '../../Inventory/InventoryForm'
import PurchaseNoteForm from './PurchaseNoteForm'
// import ViewWithTabs, { DataTabView } from '../../../components/Display/ViewWithTabs'
import { toFixed } from 'accounting'
import IMask from 'imask'
import { DateTime } from 'luxon'
import { GrCircleInformation } from 'react-icons/gr'
import { IoMdAdd } from 'react-icons/io'
import { IoAddOutline, IoDocumentAttachSharp } from 'react-icons/io5'
import { v4 as uuidv4 } from 'uuid'
import {
  createItem,
  fetchItems,
  ICreateITemDTO,
  IItem,
  IITemsResponse,
} from '../../../common/Inventory/Items'
import { fetchUnits, IUnit } from '../../../common/Inventory/Units'
import Tooltip from '../../../components/Display/Tooltip'
import Datepicker from '../../../components/Inputs/Datepicker'
import Select from '../../../components/Inputs/Select'
import Switch from '../../../components/Inputs/Switch'
import { uploadToS3 } from '../../../utils/UploadFile'
import AddItemToPurchaseForm from './AddItemToPurchaseForm'
import StepForm from './StepForm'

const server = process.env.REACT_APP_SERVER_URL
const docs_url = process.env.REACT_APP_S3_URL_DOCS

const formatPipeTotal = (
  value: string | number,
  unMaskValue: boolean = false,
  decimals: number = 2,
  min = 0
): any => {
  let unMask = unMaskValue
    ? [IMask.PIPE_TYPE.UNMASKED, IMask.PIPE_TYPE.TYPED]
    : []

  // Convertir número a string antes de procesar
  if (typeof value === 'number') {
    value = value.toString()
  }

  // Normalizar valores del backend: convertir punto decimal (US format) a coma (Latin format)
  // Solo si NO estamos unmasking y el valor NO tiene coma (indica valor raw del backend)
  if (!unMaskValue && typeof value === 'string' && !value.includes(',')) {
    value = value.replace('.', ',')
  }

  value = unMaskValue ? value.replace(/\./g, '') : value
  let numberPipe = IMask.createPipe(
    {
      mask: Number,
      thousandsSeparator: '.',
      radix: ',',
      scale: decimals,
      normalizeZeros: true,
      padFractionalZeros: decimals > 0,
      min,
    },
    ...unMask
  )
  // IMask().un
  return numberPipe(value + '')
}

const Purchase: React.FC<PurchaseProps> = ({
  // setHasData,  for unifiedLoad, deprecated
  onCreateProvider,
  onFinish,
  defaultProvider,
  onShowAddPayment = () => {},
  changePurchaseDate = () => {},
  paymentsProps = [],
  setPaymentsProps = () => {},
  onCreateItem = () => {},
  onShowAddWithholding = () => {},
  onShowAddWithholdingISLR = () => {},
  onItemsToPurchaseRightChange = (items: any) => {},
}) => {
  const today = DateTime.local().setLocale('es')

  const dispatch = useDispatch()
  const [userConfig] = useLocalStorageState('user-config')
  const userTenantId = useSelector(
    (state: RootState) => state.auth.user['custom:tenant_id']
  )

  const dealers = useSelector((state: RootState) => state.deal.dealers)
  const warehouses = useSelector((state: RootState) => state.warh.warehouses)
  const categories = useSelector((state: RootState) => state.ctgr.categories)
  const currencies = useSelector((state: RootState) => state.curr.currencies)
  const rates = useSelector((state: RootState) => state?.rates?.rates)
  const [currenciesSelect, setCurrenciesSelect] = useState(
    currencies.map((v) => ({ text: v.name, value: v.id }))
  )
  const [selectedCurrency, setSelectedCurrency] = useState<any | null>(null)
  // let selectedCurrency = useRef(currencies[0]?.id)
  const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false)
  const { addAlert } = useSnackBars()

  const [itemState, setItemState] = useState<IITemsResponse>({
    status: 0,
    numberOfPages: 0,
    items: [],
  })
  const { items } = itemState
  const [units, setUnits] = useState<IUnit[]>([])
  const [accounts, setAccounts] = useState<any[]>([])
  const [selectedAccount, setSelectedAccount] = useState<any>(null)
  const [accountsGlobal, setAccountsGlobal] = useState<any[]>([])

  const [globalRate, setGlobalRate] = useState<string>('')

  const ref = useRef<HTMLInputElement>(null)

  const amountRef = useRef<any>(null)

  const [showAddPaymentModal, setShowAddPaymentModal] = useState<boolean>(false)

  const [purchaseOriginalDate, setPurchaseOriginalDate] = useState(
    `${today.day}/${today.month}/${today.year}`
  )

  let inputSubmitFileRef = useRef<HTMLInputElement | null>(null)

  const [document, setDocument] = useState<File | null>(null)

  useEffect(() => {
    if (defaultProvider) {
      console.log('default provider', defaultProvider)
      setProviderAndHasData(defaultProvider)
    }
  }, [defaultProvider])

  const fetchDealersCall = async () => {
    try {
      setLoading(true)
      await dispatch(
        fetchDealers(
          [''],
          [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
        )
      )
    } catch (error: any) {
      addAlert({
        message: error.response?.data?.message || 'Error del Servidor',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const fetchAndSetItems = async () => {
    try {
      const response = await fetchItems(
        [''],
        [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
      )
      setItemState(response)
    } catch (error) {
      throw error
    }
  }

  const clearDealerFilter = () => {
    ref && ref.current && (ref.current.value = '')
    fetchDealersCall()
    setSearchProviderParams([])
  }

  const onSubmitImage = (e): void => {
    e.preventDefault()
    if (inputSubmitFileRef.current && inputSubmitFileRef.current.files) {
      setDocument(inputSubmitFileRef?.current?.files[0])
    }
  }

  const clearItemFilter = () => {
    fetchAndSetItems()
    setSearchItemParam([])
  }

  const fetchAndSetUnits = useCallback(async () => {
    const units = await fetchUnits()
    setUnits(units)
  }, [])

  useEffect(() => {
    setCurrenciesSelect(currencies.map((v) => ({ text: v.name, value: v.id })))
  }, [currencies])

  const calcValues = (type: 'SUBTOTAL' | 'DISCOUNT' | 'IVA' | 'TOTAL'): any => {
    // console.log('VER ITMES', itemsToPurchase)
    // console.log('ver two', itemsToPurchaseRight)
    let ivaType = { GENERAL: 0.16, REDUCED: 0.15, SUMPTUARY: 0.08, EXEMPT: 0 }

    if (type === 'SUBTOTAL') {
      return toFixed(
        itemsToPurchase.reduce((a, b) => {
          // if (b.item.currency.id === '1') {
          //   return a + (+b?.cost / +globalRate) * +b.amount
          // }
          // return a + +b?.cost * +b.amount * (b?.item?.currency?.id === '1' ? +globalRate : 1)
          return a + +b?.cost * +b.amount
        }, 0),
        2
      )
    }
    if (type === 'IVA') {
      return toFixed(
        itemsToPurchase.reduce((a, b) => {
          // return a + +b?.cost * +b.amount * ivaType[b?.item?.ivaType] * (b?.item?.currency?.id === '1' ? +globalRate : 1)
          return a + +b?.cost * +b.amount * ivaType[b?.item?.ivaType]
        }, 0),
        2
      )
    }
    if (type === 'TOTAL') {
      console.log('TOTAL', igtfInput)
      let total =
        itemsToPurchase.reduce((a, b) => {
          // return a + +b?.cost * +b.amount * ivaType[b.item.ivaType] *  (b?.item?.currency?.id === '1' ? +globalRate : 1)
          return a + +b?.cost * +b.amount * ivaType[b.item.ivaType]
        }, 0) +
        (+calcValues('SUBTOTAL') -
          +toFixed(+discountInput, 2) +
          +toFixed(+igtfInput, 2))
      return toFixed(total, 2)
    }
    // if (type === 'IGTF') {
    //   // console.log("payments en igtf", payments)
    //   let igtf = payments?.reduce((a, b) => {
    //     if (b?.account?.currency !== '2') {
    //       return a + (+b?.amount * b?.rate * 0.03)
    //     }
    //     return a
    //   }, 0)
    //   return toFixed(igtf, 2)
    // }
    return ''
  }

  const getTotalPayments = useMemo(() => {
    return paymentsProps.reduce((acc, payment) => {
      const amount = Number(payment?.amount ?? 0)
      const rate = Number(payment?.rate ?? 1)

      if (payment?.account?.currency !== '2') {
        return acc + amount * rate
      }
      return acc + amount
    }, 0)
  }, [paymentsProps])

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(
      response.data.accounts.map((v) => ({
        text: v?.description,
        value: v?.id,
      }))
    )

    setAccountsGlobal(response.data.accounts)

    setSelectedAccount({
      account: {
        text: response?.data?.accounts[0]?.description,
        value: response?.data?.accounts[0]?.id,
        currency: response?.data?.accounts[0]?.idCurrency,
      },
      date: `${today.year}/${today.month}/${today.day}`,
    })
  }

  useEffect(() => {
    try {
      setLoading(true)
      fetchDealersCall()
      // fetchAndSetItems()
      fetchAndSetUnits()
      getAccounts()
    } catch (error: any) {
      addAlert({
        message: error.response.data.message || 'Error del Servidor',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    setCategoriesValues(
      categories.map((category) => ({
        value: category?.id,
        text: category?.name,
      }))
    )
  }, [categories])

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const dealersColumns: ColumnsTable[] = [
    {
      title: 'Documento',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, dealer: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {dealer?.document.documentType}-{dealer.document.document}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'businessName',
      key: 'businessName',
      render: (name: any, client: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {client.document.documentType === 'J' ||
          client.document.documentType === 'C'
            ? client.businessName
            : client.name}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Dirección Fiscal',
      dataIndex: 'fiscalAddress',
      key: 'fiscalAddress',
      render: (x: any, dealer: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {[
            dealer?.address.city,
            dealer?.address.state,
            dealer?.address.postalCode,
          ].join(', ')}
        </ColumnItemWrapper>
      ),
    },
  ]

  const paymentsColumns: ColumnsTable[] = [
    {
      title: 'Cuenta',
      dataIndex: 'account.text',
      key: 'account.text',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any, idx) => {
        console.log('RECORD..', record)
        return (
          <ColumnItemWrapper subElement="paragraph">
            {`${getDenomination(record?.account?.currency)} ${formatPipe(
              toFixed(+record.amount, 2)
            )}`}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Fecha de egreso',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any, idx) => (
        <button
          className="flex mt-1 border-none"
          onClick={() => {
            setPaymentsProps((prevState) =>
              prevState.filter((v, index) => index !== idx)
            )
            // setPayments((prevState) =>
            //   prevState.filter((v, index) => idx !== index)
            // )
          }}
        >
          <FiTrash2 size={20} className="text-primary" />
        </button>
      ),
    },
  ]

  const [menuVisible, setMenuVisible] = useState<number>(-1)
  const [associatedCodeModal, setAssociatedCodeModal] = useState<boolean>(false)
  const [editCostsModal, setEditCostsModal] = useState<boolean>(false)
  const [itemToModify, setItemToModify] = useState<IItem | null>(null)
  const paymentType = [
    { text: 'De contado', value: 1 },
    { text: 'Crédito', value: 2 },
  ]

  const [surplusAmount, setSurplusAmount] = useState<string>('')

  const [selectedPaymentType, setSelectedPaymentType] = useState<any>(
    paymentType[0]
  )
  const [isLastPage, setIsLastPage] = useState<boolean>(false)

  const [indexDebt, setIndexDebt] = useState<boolean>(true)

  const onFilterCompund = (values, record: any): any => {
    // if (!record.compound) {
    if (!(record.type === 'COMPOUND')) {
      const { onCompound, ...val } = values
      return val
    } else {
      const { onAssociated, onTracking, ...val } = values
      return val
    }
  }

  const itemsColumns: ColumnsTable[] = [
    {
      title: 'Tipo',
      dataIndex: 'item.type',
      key: 'item.type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {getItemType(record.item.type).value}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'item.name',
      key: 'item.name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatPipe(`${record?.amount ?? 0}`, false, 0)}
        </ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Excento',
    //   dataIndex: 'exempt',
    //   key: 'exempt',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{record?.exempt ? 'Sí' : 'No'}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'Costo',
      dataIndex: 'cost',
      key: 'cost',
      render: (id: number, record: any) => {
        // console.log("record...", record)
        return (
          <ColumnItemWrapper>
            <p>Bs. {formatPipe(String(record?.cost))}</p>
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Recibido',
      dataIndex: 'received',
      key: 'received',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatPipe(`${record?.received ?? 0}`, false, 0)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <button
          className="flex mt-1 border-none"
          onClick={() => {
            setItemsToPurchase((prevState) =>
              prevState.filter((v) => v.item.id !== record.item.id)
            )
          }}
        >
          <FiTrash2 size={20} className="text-primary" />
        </button>
      ),
    },
  ]

  const itemsToLoadColumns: ColumnsTable[] = [
    {
      title: ' ',
      dataIndex: 'images',
      key: 'images',
      width: 50,
      render: (images: any[], record: any) => (
        <div className="ml-2 h-9 w-9 rounded-lg border-white dark:border-gray-700 dark:bg-dark-less border-4 flex">
          <img
            className="object-cover rounded-md"
            src={
              images?.length > 0 ? images[images.length - 1].url : defaultImage
            }
            alt={`${record?.id}-img`}
          />
        </div>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.sku ? '' : 'text-gray-600'}`}
        >
          {record?.sku ? record?.sku : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Código de barras',
      dataIndex: 'barcode',
      key: 'barcode',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.barcode ? '' : 'text-gray-600'}`}
        >
          {record?.barcode ? record?.barcode : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (id: number, record: any) => (
        <ColumnItemWrapper divStyles="text-center" subElement="paragraph">
          {+record?.quantity - +record.missing}/{record?.quantity}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Costo',
      dataIndex: 'cost',
      key: 'cost',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p
            className={`${
              record?.cost === '0.00' ? 'text-warning' : 'text-success'
            }`}
          >
            {record?.unit_cost !== '0.00' ? (
              'Bs ' + record?.cost
            ) : (
              <span>
                Sin Precio <FiAlertTriangle className="text-warning inline" />
              </span>
            )}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      key: 'actions',
      render: (id: number, record: any) => (
        <button
          className="mr-4 border-none"
          onClick={() => deleteItemFromLoad(record)}
        >
          <FiTrash2 size={20} color="red" />
        </button>
      ),
    },
  ]

  const [provider, setProvider] = useState<any | null>(null)
  const [createProviderModal, setCreateProviderModal] = useState<boolean>(false)
  const [searchDealerModal, setSearchDealerModal] = useState<boolean>(false)
  const [searchProviderParams, setSearchProviderParams] = useState<string[]>([])
  const [currentDealerPage, setCurrentDealerPage] = useState<number>(0)

  const [warehouse, setWarehouse] = useState<IWarehouse | null>(null)
  const [searchWarehouse, setSearchWarehouse] = useState<string>('')
  const [showWarehouses, setShowWarehouses] = useState<boolean>(true)

  const [itemsToPurchase, setItemsToPurchase] = useState<any[]>([])
  const [itemsToPurchaseRight, setItemsToPurchaseRight] = useState<any[]>([])
  const [currentItem, setCurrentItem] = useState<IItem | null>(null)
  const [createItemModal, setCreateItemModal] = useState<boolean>(false)
  const [searchItemModal, setSearchItemModal] = useState<boolean>(false)
  const [searchItemParams, setSearchItemParam] = useState<string[]>([])
  const [currentItemPage, setCurrentItemPage] = useState<number>(0)
  const [categoriesValues, setCategoriesValues] = useState<any[]>([])

  const [loadItemModal, setLoadItemModal] = useState<boolean>(false)

  const [editItemToLoadModal, setEditItemToLoadModal] = useState<boolean>(false)
  const [editingItem, setEditingItem] = useState<IITemToPurchase | null>(null)
  const [baseEditingItem, setBaseEditingItem] = useState<IItem | null>(null)

  const [total, setTotal] = useState<string>('0')

  const [resetModal, setResetModal] = useState<boolean>(false)

  const [confirmModal, setConfirmModal] = useState<boolean>(false)

  // const discountInput = useRef<HTMLInputElement | null>(null)
  // const igtfInput = useRef<HTMLInputElement | null>(null)
  const [discountInput, setDiscountInput] = useState<string>('0')
  const useDiscountRef = useRef<HTMLInputElement | any>('0')
  const igtfRef = useRef<HTMLInputElement | any>('0')
  const [igtfInput, setIgtfInput] = useState<string>('0')

  const [discountEditMode, setDiscountEditMode] = useState<boolean>(false)
  const [igtfEditMode, setIgtfEditMode] = useState<boolean>(false)
  const [payments, setPayments] = useState<any[]>([])

  const paymentsWithoutHolding = useMemo(() => {
    return (
      payments.filter(
        (payment) =>
          payment.account.text !== 'Retención IVA' &&
          payment.account.text !== 'Retención ISLR'
      ) || []
    )
  }, [payments])

  useEffect(() => {
    console.log('payments props', paymentsProps)
    setPayments(paymentsProps)
  }, [paymentsProps])

  const [purchaseNote, setPurchaseNote] =
    useState<{
      bookDate: string
      emisionDate: string
      expirationDate: string
      serial: string
      control: string
      notes: string
    } | null>(null)
  const [editingLoadNote, setEditingLoadNote] =
    useState<{
      bookDate: string
      emisionDate: string
      expirationDate: string
      serial: string
      notes: string
    } | null>(null)
  const [purchaseNoteModal, setPurchaseNoteModal] = useState<boolean>(false)

  const [cashForm, setCashForm] = useState<any | null>(null)
  const [creditForm, setCreditForm] = useState<any | null>(null)
  const [bill, setBill] = useState<any | null>(null)

  const [showModal, setshowModal] = useState<boolean>(false)
  const [paymentTotalGlobal, setPaymentTotalGlobal] = useState<number>(0)

  const [purchaseDate, setPurchaseDate] = useState<string>('')

  useEffect(() => {
    onItemsToPurchaseRightChange(itemsToPurchaseRight)
  }, [itemsToPurchaseRight])

  const setProviderAndHasData = (value) => {
    setProvider(value)
    // if (value) {
    //   setHasData(true)
    //   return
    // }
    // setHasData(false)
  }

  const resetAll = () => {
    setProviderAndHasData(null)
    setWarehouse(null)
    setPurchaseNote(null)
    setItemsToPurchase([])
    setResetModal(false)
    setEditingLoadNote(null)
  }

  // useEffect(() => {
  //   console.log('itemsToLoad: ', itemsToLoad)
  // }, [itemsToLoad])

  const searchDealer = async (e) => {
    const value = e.target.value
    // const valueWithoutSpaces = value.replace(/\s{2,}/g, ' ').trim()
    if (value) {
      setSearchProviderParams([`fastSearch=${value}`])
    } else {
      setSearchProviderParams([])
    }
    await dispatch(
      fetchDealers(
        [`fastSearch=${value}`],
        [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      )
    )
  }

  const deleteItemFromLoad = (item: IITemToPurchase) => {
    setItemsToPurchase((prev) => prev.filter((i) => i.id !== item.id))
  }

  useEffect(() => {
    setTotal(
      toFixed(
        itemsToPurchase.reduce(
          (acc, i) => acc + (Number(i?.cost) || 0) * Number(i.quantity),
          0
        ),
        2
      )
    )
  }, [itemsToPurchase])

  useEffect(() => {
    if (itemsToPurchase.length) {
      let numberMask = IMask(useDiscountRef.current, {
        mask: Number,
        thousandsSeparator: '.',
        radix: ',',
        scale: 2,
        normalizeZeros: true,
        padFractionalZeros: true,
        // signed: false,
        max: 10000000000000,
      })
      numberMask.on('accept', () => {
        console.log('ESCRIBEE...')
        setDiscountInput(numberMask.unmaskedValue)
      })

      let numberIgtfMask = IMask(igtfRef.current, {
        mask: Number,
        thousandsSeparator: '.',
        radix: ',',
        scale: 2,
        normalizeZeros: true,
        padFractionalZeros: true,
        // signed: false,
        max: 10000000000000,
      })

      numberIgtfMask.on('accept', () => {
        console.log('igtf input...')
        setIgtfInput(numberIgtfMask.unmaskedValue)
      })
    }
  }, [itemsToPurchase])

  useEffect(() => {
    // if (dealers?.length > 0 && warehouse && itemsToPurchaseRight?.length > 0 && !isLastPage) {
    // if (warehouse && itemsToPurchaseRight?.length > 0 && !isLastPage) {
    //   console.log("entra...")
    //   let element = document.getElementById('input-amount') as HTMLElement
    //   let numberMask = IMask(element, {
    //     mask: Number,
    //     thousandsSeparator: '.',
    //     radix: ',',
    //     scale: 2,
    //     normalizeZeros: true,
    //     padFractionalZeros: true,
    //     // min: 1,
    //     max: 10000000000000
    //   })
    //   numberMask.on('accept', () => {
    //     console.log("valor...", numberMask.unmaskedValue)
    //     setSelectedAccount((prevState) => ({
    //           ...prevState,
    //           amount: numberMask.unmaskedValue,
    //         }))
    //   })
    // }
  }, [isLastPage, dealers, warehouse, itemsToPurchaseRight])

  // searchItem
  const [, setCurrentEvaluate] = useState<string>('none')

  const [loading, setLoading] = useState<boolean>(false)

  const updateMethod = (
    item: IItem,
    costAndPrice: ICostAndQuantity,
    rotation: IRotationForm
  ) => {
    const index = itemsToPurchase.map((i) => i.id).indexOf(item.id)
    if (index === -1) {
      addAlert({
        message: 'Error, artículo no incluido',
        status: 'error',
      })
      return
    } else {
      const itemToUpdate = {
        id: item.id,
        image: item.images[0]?.url,
        barcode: item.barcode,
        sku: item.sku,
        name: item.name,

        quantity: costAndPrice.quantity,
        loaded_quantity: costAndPrice.loaded_quantity,
        missing: costAndPrice.missing,
        cost: costAndPrice.cost,
        price: costAndPrice.price,
        total: costAndPrice.total,
        calc_unit_cost: costAndPrice.calc_unit_cost,
        prev_cost: costAndPrice.prev_cost,

        creation_date: getISOtime(rotation.creation_date),
        expiration_date: getISOtime(rotation.expiration_date),
        rotation_date: getISOtime(rotation.rotation_date),
        batch: rotation.batch,
      }
      const itemsCopy = [...itemsToPurchase]
      itemsCopy[index] = itemToUpdate
      setItemsToPurchase(itemsCopy)
    }
    addAlert({
      message: 'Artículo actualizado con éxito!',
      status: 'success',
    })
  }

  const onPressRowItem = (item: IItem) => {
    const index = itemsToPurchase.map((i) => i.id).indexOf(item.id)
    if (index !== -1) {
      addAlert({
        message:
          'Artículo ya incluido. Si desea editarlo, hágalo en la lista de la derecha',
        status: 'error',
      })
      return
    }
    setCurrentItem(item)
    setLoadItemModal(true)
  }

  const bigLoadMethod = async (
    item: IItem,
    costAndPrice: ICostAndQuantity,
    rotation: IRotationForm
  ) => {
    const index = itemsToPurchase.map((i) => i.id).indexOf(item.id)
    if (index !== -1) {
      addAlert({
        message:
          'Artículo ya incluido. Si desea editarlo, hágalo en la lista de la derecha',
        status: 'error',
      })
      return
    } else {
      setItemsToPurchase((prev) => [
        ...prev,
        {
          id: item.id,
          image: item.images[0]?.url,
          barcode: item.barcode,
          sku: item.sku,
          name: item.name,

          quantity: costAndPrice.quantity,
          loaded_quantity: costAndPrice.loaded_quantity,
          missing: costAndPrice.missing,
          cost: costAndPrice.cost,
          price: costAndPrice.price,
          total: costAndPrice.total,
          calc_unit_cost: costAndPrice.calc_unit_cost,
          prev_cost: costAndPrice.prev_cost,

          creation_date: getISOtime(rotation.creation_date),
          expiration_date: getISOtime(rotation.expiration_date),
          rotation_date: getISOtime(rotation.rotation_date),
          batch: rotation.batch,
        },
      ])
    }
    addAlert({
      message: 'Artículo precargado con éxito!',
      status: 'success',
    })
  }

  const getCurrentPageColor = (i: number): string => {
    if (
      i === 0 &&
      !provider &&
      !warehouse &&
      itemsToPurchaseRight.length === 0
    ) {
      return '#006AEA'
    }
    if (
      i === 1 &&
      provider &&
      !warehouse &&
      itemsToPurchaseRight.length === 0
    ) {
      return '#006AEA'
    }
    if (i === 2 && provider && warehouse && itemsToPurchaseRight.length === 0) {
      return '#006AEA'
    }
    if (
      i === 3 &&
      provider &&
      warehouse &&
      itemsToPurchaseRight.length > 0 &&
      !isLastPage
    ) {
      return '#006AEA'
    }
    if (
      i === 4 &&
      itemsToPurchaseRight.length &&
      provider &&
      warehouse &&
      isLastPage
    ) {
      return '#006AEA'
    }
    return '#D9D9D9'
  }

  const goBack = (): void => {
    // setItemsToPurchase([])

    if (provider && !warehouse && itemsToPurchaseRight.length === 0) {
      setProvider(null)
    }

    if (provider && warehouse && itemsToPurchaseRight.length === 0) {
      setSearchWarehouse('')
      setWarehouse(null)
    }

    if (provider && warehouse && itemsToPurchaseRight.length && !isLastPage) {
      setItemsToPurchaseRight([])
    }

    if (provider && warehouse && itemsToPurchaseRight.length && isLastPage) {
      setIsLastPage(false)
      setCashForm(null)
      setCreditForm(null)
    }
  }

  const goForward = () => {
    // console.log('VER...', selectedPaymentType.value)
    // console.log('cash', cashForm)
    setItemsToPurchaseRight([])
    if (itemsToPurchase.length > 0 && provider && warehouse && !isLastPage) {
      setItemsToPurchaseRight(itemsToPurchase)
    }
    if (
      itemsToPurchaseRight.length &&
      provider &&
      warehouse &&
      ((selectedPaymentType.value === 1 && paymentsWithoutHolding.length > 0) ||
        (selectedPaymentType.value === 2 &&
          creditForm?.installmentQuantity &&
          creditForm?.installmentRange &&
          creditForm?.date))
    ) {
      setIsLastPage(true)
    }

    if (
      itemsToPurchaseRight.length &&
      provider &&
      warehouse &&
      paymentsWithoutHolding.length === 0 &&
      selectedPaymentType.value === 1
    ) {
      addAlert({
        message: 'Debe de realizar al menos un pago para ir al siguiente paso',
        status: 'error',
      })
    }

    if (
      itemsToPurchaseRight.length &&
      provider &&
      warehouse &&
      payments.length === 0 &&
      selectedPaymentType.value === 2 &&
      (!creditForm?.installmentQuantity ||
        !creditForm?.installmentRange ||
        !creditForm?.date)
    ) {
      addAlert({
        message: 'Debe de ingresar todos los valores',
        status: 'error',
      })
    }
  }

  const returnBody = (surplusAction: 'RECEIVABLE' | 'ADVANCE') => {
    if (bill?.code && bill?.control && bill?.description) {
      return {
        provider: {
          id: provider.id,
        },
        paidOut: true,
        delivered: itemsToPurchaseRight.every(
          (item) => item.received === item.amount
        ),
        description: bill?.description,
        purchaseCost: +toFixed(+calcValues('TOTAL'), 2),
        surplusAction,
        discount: discountInput,
        iva: +toFixed(calcValues('IVA'), 2),
        // igtf: +toFixed(calcValues('IGTF'), 2),
        igtf: igtfInput,
        date: purchaseDate,
        // date: DateTime.now()
        //   .setLocale('zh')
        //   .toLocaleString()
        //   .replaceAll('/', '-'),
        currency: {
          id: '2',
        },
        destination: {
          id: warehouse?.id,
        },
        items: itemsToPurchaseRight.map((v) => {
          const itemCurrencyId = v?.item?.currency?.id || '2'
          const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
          return {
            ...v.item,
            ...v,
            cost: toFixed(+v?.cost, 2),
            price: toFixed(+v?.item?.price * currencyRate, 2),
            currency: { id: '2' },
          }
        }),
        bill: {
          ...bill,
          date: dateToDB(bill.emissionDate),
          total: +toFixed(+calcValues('TOTAL'), 2),
          discount: toFixed(+discountInput, 2),
          iva: toFixed(+calcValues('IVA'), 2),
          // igtf: toFixed(+calcValues('IGTF'), 2),
          igtf: igtfInput,
        },
        payments: paymentsWithoutHolding.map((v) => ({
          ...v,
          date: dateToDB(v.date),
          account: { id: v.account.value },
          currency: {
            id: v.account.currency,
          },
        })),
      }
    } else {
      return {
        provider: {
          id: provider.id,
        },
        paidOut: true,
        delivered: itemsToPurchaseRight.every(
          (item) => item.received === item.amount
        ),
        description: 'N/A',
        purchaseCost: +toFixed(+calcValues('TOTAL'), 2),
        surplusAction,
        date: purchaseDate,
        // date: DateTime.now()
        //   .setLocale('zh')
        //   .toLocaleString()
        //   .replaceAll('/', '-'),
        // date: "2022-07-25",
        discount: discountInput,
        iva: toFixed(calcValues('IVA'), 2),
        // igtf: toFixed(calcValues('IGTF'), 2),
        igtf: igtfInput,
        currency: {
          id: '2',
        },
        destination: {
          id: warehouse?.id,
        },
        items: itemsToPurchaseRight.map((v) => {
          const itemCurrencyId = v?.item?.currency?.id || '2'
          const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
          return {
            ...v.item,
            amount: v.amount,
            barcode: v.barcode,
            received: v.received,
            cost: toFixed(+v?.cost, 2),
            price: toFixed(+v?.item?.price * currencyRate, 2),
            currency: { id: '2' },
          }
        }),
        payments: paymentsWithoutHolding.map((v) => ({
          ...v,
          account: { id: v.account.value },
          date: dateToDB(v.date),
          currency: {
            id: v.account.currency,
          },
        })),
      }
    }
  }

  const finishPurchase = async (): Promise<void> => {
    console.log('bill...', bill)
    if ((!bill?.code && !bill?.control) || (bill.code && bill.control)) {
      console.log('bill llegandooo...', bill)
      /** Hacer peticion */
      // console.log('ver bill...', bill)
      let body: any = {}
      if (selectedPaymentType.value === 1) {
        let paymentTotal = payments.reduce((a, b) => {
          return a + +b.amount * +b.rate
        }, 0)
        paymentTotal = +toFixed(paymentTotal, 2)
        // console.log('payment total', paymentTotal)
        // console.log('payment total', +calcValues('TOTAL'))
        let total = +calcValues('TOTAL')
        // console.log("TOTAL", total)
        setPaymentTotalGlobal(paymentTotal)
        // console.log("right...", itemsToPurchaseRight)
        // console.log('payment total', paymentTotal)
        console.log('payment total...', paymentTotal)
        console.log('total...', total)
        console.log('next total', paymentTotal - total)
        if (paymentTotal > total) {
          setSurplusAmount(toFixed(paymentTotal - total, 2))
          setshowModal(true)
          return
          // if (bill?.code && bill?.control && bill?.description) {
          //   body = {
          //     provider: {
          //       id: provider.id,
          //     },
          //     paidOut: true,
          //     delivered: false,
          //     description: '',
          //     purchaseCost: calcValues('TOTAL'),
          //     discount: discountInput,
          //     iva: calcValues('IVA'),
          //     igtf: igtfInput,
          //     date: DateTime.now()
          //       .setLocale('zh')
          //       .toLocaleString()
          //       .replaceAll('/', '-'),
          //     currency: {
          //       id: '2',
          //     },
          //     destination: {
          //       id: warehouse?.id,
          //     },
          //     items: itemsToPurchaseRight.map((v) => {
          //       return {
          //         ...v.item,
          //         ...v,
          //       }
          //     }),
          //     bill: {
          //       ...bill,
          //       emissionDate: dateToDB(bill.emissionDate),
          //       total: calcValues('TOTAL'),
          //       discount: discountInput,
          //       iva: calcValues('IVA'),
          //       igtf: igtfInput,
          //     },
          //     payments: payments.map((v) => ({
          //       ...v,
          //       date: dateToDB(v.date),
          //       account: { id: v.account.value },
          //       currency: {
          //         id: v.account.currency,
          //       },
          //     })),
          //   }
          // } else {
          //   body = {
          //     provider: {
          //       id: provider.id,
          //     },
          //     paidOut: true,
          //     delivered: false,
          //     description: 'descripcion',
          //     purchaseCost: calcValues('TOTAL'),
          //     date: DateTime.now()
          //       .setLocale('zh')
          //       .toLocaleString()
          //       .replaceAll('/', '-'),
          //     // date: "2022-07-25",
          //     discount: discountInput,
          //     iva: calcValues('IVA'),
          //     igtf: igtfInput,
          //     currency: {
          //       id: '2',
          //     },
          //     destination: {
          //       id: warehouse?.id,
          //     },
          //     items: itemsToPurchaseRight.map((v) => {
          //       return {
          //         ...v.item,
          //         amount: v.amount,
          //         barcode: v.barcode,
          //         received: v.received,
          //       }
          //     }),
          //     payments: payments.map((v) => ({
          //       ...v,
          //       account: { id: v.account.value },
          //       date: dateToDB(v.date),
          //       currency: {
          //         id: v.account.currency,
          //       },
          //     })),
          //   }
          // }
        } else if (paymentTotal === +calcValues('TOTAL')) {
          if (bill?.code && bill?.control) {
            body = {
              provider: {
                id: provider.id,
              },
              paidOut: true,
              delivered: itemsToPurchaseRight.every(
                (item) => item.received === item.amount
              ),
              description: bill?.description || '',
              purchaseCost: +toFixed(+calcValues('TOTAL'), 2),
              discount: discountInput,
              iva: calcValues('IVA'),
              // igtf: calcValues('IGTF'),
              igtf: igtfInput,
              date: purchaseDate,
              // date: DateTime.now()
              //   .setLocale('zh')
              //   .toLocaleString()
              //   .replaceAll('/', '-'),
              currency: {
                id: '2',
              },
              destination: {
                id: warehouse?.id,
              },
              items: itemsToPurchaseRight.map((v) => {
                const itemCurrencyId = v?.item?.currency?.id || '2'
                const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
                return {
                  ...v.item,
                  ...v,
                  cost: toFixed(+v?.cost, 2),
                  price: toFixed(+v?.item?.price * currencyRate, 2),
                  currency: { id: '2' },
                }
              }),
              bill: {
                ...bill,
                date: dateToDB(bill.emissionDate),
                total: toFixed(+calcValues('TOTAL'), 2),
                discount: discountInput,
                iva: calcValues('IVA'),
                // igtf: calcValues('IGTF'),
                igtf: igtfInput,
              },
              payments: paymentsWithoutHolding.map((v) => ({
                ...v,
                date: dateToDB(v.date),
                account: { id: v.account.value },
                currency: {
                  id: v.account.currency,
                },
              })),
            }
          } else {
            body = {
              provider: {
                id: provider.id,
              },
              paidOut: true,
              delivered: itemsToPurchaseRight.every(
                (item) => item.received === item.amount
              ),
              description: 'N/A',
              purchaseCost: toFixed(+calcValues('TOTAL'), 2),
              date: purchaseDate,
              // date: DateTime.now()
              //   .setLocale('zh')
              //   .toLocaleString()
              //   .replaceAll('/', '-'),
              // date: "2022-07-25",
              discount: discountInput,
              iva: calcValues('IVA'),
              // igtf: calcValues('IGTF'),
              igtf: igtfInput,
              currency: {
                id: '2',
              },
              destination: {
                id: warehouse?.id,
              },
              items: itemsToPurchaseRight.map((v) => {
                const itemCurrencyId = v?.item?.currency?.id || '2'
                const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
                return {
                  ...v.item,
                  cost: toFixed(+v?.cost, 2),
                  price: toFixed(+v?.item?.price * currencyRate, 2),
                  amount: v.amount,
                  barcode: v.barcode,
                  received: v.received,
                  currency: { id: '2' },
                }
              }),
              payments: paymentsWithoutHolding.map((v) => ({
                ...v,
                account: { id: v.account.value },
                date: dateToDB(v.date),
                currency: {
                  id: v.account.currency,
                },
              })),
            }
          }
        } else {
          addAlert({
            message: 'Los pagos deben de ser mayor o igual al monto total',
            status: 'error',
          })
          return
        }
      } else {
        let [daysFinal, monthsFinal, yearFinal] =
          creditForm?.finalDate.split('/')
        let [daysStart, monthsStart, yearStart] = creditForm?.date.split('/')
        // let [day, month, year] = creditForm?.date.split('/')

        let finalDate = DateTime.local(+yearFinal, +monthsFinal, +daysFinal)
          .setLocale('zh')
          .toLocaleString()
          .replaceAll('/', '-')

        let startDate = DateTime.local(+yearStart, +monthsStart, +daysStart)
          .setLocale('zh')
          .toLocaleString()
          .replaceAll('/', '-')

        const today = DateTime.local().setLocale('us').toFormat('yyyy-MM-dd')

        if (bill?.code && bill?.control && bill?.description) {
          body = {
            provider: {
              id: provider.id,
            },
            paidOut: false,
            delivered: itemsToPurchaseRight.every(
              (item) => item.received === item.amount
            ),
            description: bill?.description,
            purchaseCost: calcValues('TOTAL'),
            discount: discountInput,
            iva: calcValues('IVA'),
            igtf: igtfInput,
            finalDate: finalDate,
            currency: {
              id: '2',
            },
            destination: {
              id: warehouse?.id,
            },
            items: itemsToPurchaseRight.map((v) => {
              const itemCurrencyId = v?.item?.currency?.id || '2'
              const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
              return {
                ...v.item,
                ...v,
                cost: toFixed(+v?.cost, 2),
                price: toFixed(+v?.item?.price * currencyRate, 2),
                currency: { id: '2' },
              }
            }),
            credit: {
              ...creditForm,
              date: today,
              startDate,
              finalDate,
              indexation: indexDebt,
            },
            bill: {
              ...bill,
              total: calcValues('TOTAL'),
              discount: discountInput,
              iva: calcValues('IVA'),
              igtf: igtfInput,
              date: dateToDB(bill.emissionDate),
            },
          }
        } else {
          body = {
            provider: {
              id: provider.id,
            },
            paidOut: false,
            delivered: itemsToPurchaseRight.every(
              (item) => item.received === item.amount
            ),
            description: 'N/A',
            purchaseCost: calcValues('TOTAL'),
            discount: discountInput,
            iva: calcValues('IVA'),
            igtf: igtfInput,
            finalDate: finalDate,
            currency: {
              id: '2',
            },
            destination: {
              id: warehouse?.id,
            },
            items: itemsToPurchaseRight.map((v) => {
              const itemCurrencyId = v?.item?.currency?.id || '2'
              const currencyRate = itemCurrencyId === '2' ? 1 : +(rates?.find((r: any) => r.id === itemCurrencyId)?.rate || 1)
              return {
                ...v.item,
                ...v,
                cost: toFixed(+v?.cost, 2),
                price: toFixed(+v?.item?.price * currencyRate, 2),
                currency: { id: '2' },
              }
            }),
            credit: {
              ...creditForm,
              date: today,
              startDate,
              finalDate,
              indexation: indexDebt,
            },
          }
        }
      }
      try {
        addAlert({
          message: 'Creando compra...',
          status: 'loading',
        })
        let s3InfoResponse: { value: any } = { value: {} }
        console.log('docs...', docs_url)
        // ${tenantId}/${uuidv4()}_${file.name}
        if (document) {
          await uploadToS3(
            document,
            s3InfoResponse,
            `${userTenantId}/purchases/${uuidv4()}_${document?.name}`,
            userTenantId,
            docs_url
          )
        }
        let resp = await axios.post(`${server}/purchase`, {
          ...body,
          bill: body?.bill
            ? {
                ...body?.bill,
                document: document
                  ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                  : null,
              }
            : null,
        })

        let withholding = paymentsProps.find(
          (v) => v.account.text === 'Retención IVA'
        )

        if (withholding) {
          const withholdingBody = {
            amountWithheld: withholding?.amountWithheld,
            withholdingPercentage: withholding?.withholdingPercentage,
            taxBase: withholding?.taxBase,
            excempt: withholding?.excempt,
            voucherNumber: withholding?.voucherNumber,
            taxRate: withholding?.taxRate,
            taxTotal: withholding?.taxTotal,
            id: resp?.data?.purchase?.id,
          }

          await axios.post(`${server}/purchase/withholding`, withholdingBody)
        }

        let withholdingISLR = paymentsProps.find(
          (v) => v.account.text === 'Retención ISLR'
        )

        if (withholdingISLR) {
          const withholdingISLRBody = {
            amountWithheld: withholdingISLR?.amountWithheld,
            withholdingPercentage: withholdingISLR?.withholdingPercentage,
            taxBase: withholdingISLR?.taxBase,
            excempt: withholdingISLR?.excempt,
            subtrahend: withholdingISLR?.subtrahend,
            voucherNumber: withholdingISLR?.voucherNumber,
            taxRate: withholdingISLR?.taxRate,
            taxTotal: withholdingISLR?.taxTotal,
            id: resp?.data?.purchase?.id,
          }

          await axios.post(`${server}/purchase/islr-withholding`, withholdingISLRBody)
        }

        setPaymentsProps([])
        addAlert({
          message: 'Compra creada con exito',
          status: 'success',
        })
        onFinish()
      } catch (err) {
        addAlert({
          message: 'Error al crear compra',
          status: 'error',
        })
      }
      // addAlert({
      //   message: 'Compra realizada con éxito',
      //   status: 'success',
      // })

      return
    }

    /** Tirar mensaje de error */
    addAlert({
      message: 'Campos requeridos',
      status: 'error',
    })
  }

  const searchItem = async (values: InventorySearch): Promise<void> => {
    if (values.typeSelected === 'code') {
      setCurrentEvaluate('code')
      setSearchItemParam([`code=${values.code}`])
      if (currentItemPage === 0) {
        setLoading(true)
        // await dispatch(
        const itemsSearched = await fetchItems(
          [`code=${values.code}`],
          [
            `pageNumber=${currentItemPage + 1}`,
            `pageSize=${userConfig.rowsPerPage}`,
          ],
          'code'
        )
        // )
        setItemState(itemsSearched)
        setLoading(false)
      } else {
        setCurrentItemPage(0)
      }
    }

    if (values.typeSelected === 'keywords') {
      setCurrentEvaluate('name')
      setSearchItemParam([`name=${values.name}`])
      if (currentItemPage === 0) {
        setLoading(true)
        // await dispatch(
        const itemsSearched = await fetchItems(
          [`name=${values.name}`],
          [
            `pageNumber=${currentItemPage + 1}`,
            `pageSize=${userConfig.rowsPerPage}`,
          ],
          'name'
        )
        // )
        setItemState(itemsSearched)
        setLoading(false)
      } else {
        setCurrentItemPage(0)
      }
    }

    if (values.typeSelected === 'category') {
      if (currentItemPage === 0) {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setLoading(true)
          // await dispatch(
          const itemsSearched = await fetchItems(
            [`idSubCategory=${values.subCategory}`],
            [
              `pageNumber=${currentItemPage + 1}`,
              `pageSize=${userConfig.rowsPerPage}`,
            ],
            'subcategory'
          )
          // )
          setItemState(itemsSearched)
          setLoading(false)
          setSearchItemParam([`idSubCategory=${values.subCategory}`])
        } else {
          setCurrentEvaluate('category')
          setLoading(true)
          // await dispatch(
          const itemsSearched = await fetchItems(
            [`idCategory=${values.category}`],
            [
              `pageNumber=${currentItemPage + 1}`,
              `pageSize=${userConfig.rowsPerPage}`,
            ],
            'category'
          )
          // )
          setItemState(itemsSearched)
          setLoading(false)
          setSearchItemParam([`idCategory=${values.category}`])
        }
      } else {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setSearchItemParam([`idSubCategory=${values.subCategory}`])
          setCurrentItemPage(0)
        } else {
          setCurrentEvaluate('category')
          setSearchItemParam([`idCategory=${values.category}`])
          setCurrentItemPage(0)
        }
      }
    }
    setSearchItemModal(false)
  }

  const createDealerMethod = async (values) => {
    // toUpperValues(values)
    // console.log(JSON.stringify(values, null, 2))
    // setLoading(true)
    // try {
    //   addAlert({ message: 'Creando proveedor...', status: 'loading' })
    //   const { phones, ...rest } = values
    //     const [phone1, phone2] = phones
    //     const _values: { provider: Omit<IDealer, 'id'> } = {
    //       ...rest,
    //       phone1: phone1?.number || null,
    //       phone2: phone2?.number || null,
    //     }
    //   // const _values: { provider: Omit<IDealer, 'id'> } = {
    //   //   provider: {
    //   //     ...values,
    //   //   },
    //   // }
    //   // await dispatch(createDealer(_values))
    //   const parsedPhones = _values.provider.phones.map((phone: IPhone) => ({
    //     ...phone,
    //     id: Number(phone.id),
    //   }))
    //   const response: AxiosResponse<{
    //     status: number
    //     newProvider: IDealer
    //   }> = await axios.post(`${server}/thirdparty/provider`, {
    //     ..._values,
    //     phones: parsedPhones,
    //   })
    //   setSearchProviderParams([])

    //   if (currentDealerPage === 0) {
    //     setLoading(true)
    //     fetchDealers(
    //       [],
    //       [
    //         `pageNumber=${currentDealerPage + 1}`,
    //         `pageSize=${userConfig.rowsPerPage}`,
    //       ]
    //     )
    //     setLoading(false)
    //     setProviderAndHasData(response.data.newProvider)
    //     // setHasData(true)
    //   } else {
    //     setCurrentDealerPage(0)
    //   }
    //   addAlert({ message: 'Proveedor creado con éxito', status: 'success' })
    //   setCreateProviderModal(false)
    // } catch (e) {
    //   addAlert({
    //     message: 'Error al crear o actualizar proveedor',
    //     status: 'error',
    //   })
    // } finally {
    //   setLoading(false)
    // }

    // console.log('VER', values.dealerFile)
    // toUpperValues(values)
    // console.log(JSON.stringify(values, null, 2))
    const fd = new FormData()
    setLoading(true)
    try {
      if (!values.id) {
        addAlert({ message: 'Creando proveedor...', status: 'loading' })
        const { phones, ...rest } = values
        const [phone1, phone2] = phones
        const _values: { provider: Omit<IDealer, 'id'> } = {
          ...rest,
          phone1: phone1?.number || null,
          phone2: phone2?.number || null,
        }
        // console.log('_values', _values)
        if (values.dealerFile) {
          fd.append('media', values.dealerFile)
          fd.append('fileType', 'pdf')
          await dispatch(createDealer(_values, true, fd))
          // if (currentPage === 0) {
          //   setLoading(true)
          //   fetchDealers(
          //     [],
          //     [
          //       `pageNumber=${currentPage + 1}`,
          //       `pageSize=${userConfig.rowsPerPage}`,
          //     ]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
          // setSearchParams([])
          await fetchDealersCall()
          addAlert({ message: 'Proveedor creado con éxito', status: 'success' })
          // setModal(false)
          setCreateProviderModal(false)
        } else {
          try {
            let response: any = await dispatch(createDealer(_values, false, fd))
            // console.log("response...", response.data.provider)
            setSearchProviderParams([])
            setProviderAndHasData(response.data.provider)
            addAlert({
              message: 'Proveedor creado con éxito',
              status: 'success',
            })
            await fetchDealersCall()
            setCreateProviderModal(false)
          } catch (err) {
            addAlert({ message: 'Error al crear proveedor', status: 'error' })
          }

          // if (currentPage === 0) {
          //   setLoading(true)
          //   fetchDealers(
          //     [],
          //     [
          //       `pageNumber=${currentPage + 1}`,
          //       `pageSize=${userConfig.rowsPerPage}`,
          //     ]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
          // setSearchParams([])
          // setModal(false)
        }
      } else {
        if (values.dealerFile) {
          fd.append('media', values.dealerFile)
          fd.append('fileType', 'pdf')
          addAlert({ message: 'Actualizando proveedor...', status: 'loading' })
          const _values: { provider: IDealer } = {
            provider: {
              ...values,
            },
          }
          await dispatch(updateDealer(_values, true, fd))
          addAlert({
            message: 'Proveedor actualizado con éxito',
            status: 'success',
          })
          // setModal(false)
          setCreateProviderModal(false)
        } else {
          addAlert({ message: 'Actualizando proveedor...', status: 'loading' })
          const _values: { provider: IDealer } = {
            provider: {
              ...values,
            },
          }
          await updateDealer(_values, false, fd)
          addAlert({
            message: 'Proveedor actualizado con éxito',
            status: 'success',
          })
          // setModal(false)
          setCreateProviderModal(false)
        }
      }
    } catch (e) {
      addAlert({
        message: 'Error al crear o actualizar proveedor',
        status: 'error',
      })
    } finally {
      setLoading(false)
      // setSelected(null)
    }
  }

  const createItemMethod = async (values): Promise<void> => {
    // const profit = +(values.profit / 100).toFixed(2)
    // const tax = +(values.tax / 100).toFixed(2) || 0
    // const price = +(values.cost * profit).toFixed(2)
    // const category = { id: +values.category }
    const fd = new FormData()

    // try {
    if (values.barcode === '' && values.sku === '') {
      addAlert({
        message: 'Especifique al menos un código de barras o un SKU',
        status: 'error',
      })
      return
    }

    if (values.barcode === values.sku) {
      addAlert({
        message: 'El código de barras y el SKU deben ser distintos',
        status: 'error',
      })
      return
    }

    // if (values.compound) {
    if (values.type === 'COMPOUND') {
      values.unit = '1'
      values.brand = ''
      values.barcode = null
    }

    values.barcode === '' && (values.barcode = null)
    values.sku === '' && (values.sku = null)

    setLoading(true)

    const {
      barcode,
      sku,
      brand,
      category,
      description,
      exempt: boolean,
      imageToDelete,
      name,
      subcategory,
      type,
      unit,
      price,
      cost,
      currency,
      ivaType,
    } = values

    const newItem: ICreateITemDTO = {
      barcode,
      sku,
      brand,
      category,
      cost,
      price,
      description,
      exempt: boolean,
      imageToDelete,
      name,
      subcategory,
      type,
      unit: {
        id: unit,
      },
      currency,
      ivaType,
    }

    addAlert({ message: 'Creando Articulo...', status: 'loading' })

    let response: any = {}

    if (values.image) {
      // console.log('llega...', userTenantId)
      fd.append('media', values.image)
      fd.append('fileType', 'photo')
      // values.image.name = `${userTenantId}`
      response = await createItem(newItem, true, fd, values.image, userTenantId)
      delete values.image
    } else {
      response = await createItem(newItem, false, fd)
    }

    setCreateItemModal(false)
    addAlert({ message: 'Artículo creado', status: 'success' })

    // const _values: Omit<IItem, 'id'> = {
    //   ...values,
    // }
    // const response: AxiosResponse<{
    //   status: number
    //   newItem: IItem
    // }> = await axios.post(`${server}/inventory/item`, {
    //   entity: {
    //     ..._values,
    //     unit: {
    //       id: _values.unit,
    //     },
    //   },
    // })
    //   let newItem = response.data.newItem
    //   if (values.image) {
    //     fd.append('media', values.image)
    //     fd.append('fileType', 'photo')
    //     const response2: AxiosResponse<any> = await axios.put(
    //       `${server}/media/file?idEntity=${newItem.id}&entity=item`,
    //       fd
    //     )
    //     const image = {
    //       url: response2.data.file,
    //     }
    //     newItem.images[0].url = image.url
    //     // delete values.image
    //   }
    //   // await fetchItems(searchParams, [
    //   //   `pageNumber=${currentPage + 1}`,
    //   //   `pageSize=${userConfig.rowsPerPage}`,
    //   // ])
    //   addAlert({ message: 'Articulo creado!', status: 'success' })
    //   setCreateItemModal(false)
    //   setLoading(false)
    //   setCurrentItem(newItem)
    //   setLoadItemModal(true)
    // } catch (error: any) {
    //   addAlert({
    //     message: error.response.data.message,
    //     status: 'error',
    //   })
    // } finally {
    //   setLoading(false)
    // }
  }

  const updatePriceMethod = (id: string, cost: string) => {
    itemsToPurchase.forEach((item) => {
      if (item.id === id) {
        item.cost = cost
      }
    })
  }

  const createPurchase = async () => {
    try {
      if (provider && warehouse && itemsToPurchase.length > 0 && purchaseNote) {
        // console.log('itemstopurchase: ', itemsToPurchase)
        addAlert({
          message: 'Cargando Compra',
          status: 'loading',
        })

        const missingCost = toFixed(
          itemsToPurchase.reduce(
            (acc, item) => acc + +item.missing * +item.cost,
            0
          ),
          2
        )

        const entity: Omit<ICreatePurchaseDTO, 'id'> = {
          // itemsToPurchase,
          // provider,
          // warehouse,
          // loadNote,
          provider: {
            id: String(provider.id),
          },
          paid: false,
          cost: total,
          currency: {
            id: '2',
          },
          load: {
            destination: {
              id: warehouse.id,
              locationType: 'warehouse',
            },
            items: itemsToPurchase.map((i) => ({
              idItem: i.id,
              amount: i.loaded_quantity,
            })),
          },
          invoice: {
            emissionDate: getISOtime(purchaseNote.emisionDate),
            expirationDate: getISOtime(purchaseNote.expirationDate),
            bookDate: getISOtime(purchaseNote.bookDate),
            codeInvoice: purchaseNote.serial,
            description: purchaseNote.notes,
            total,
            control: purchaseNote.control,
            discount: '0.00',
            items: itemsToPurchase,
            missingCost,
          },
        }
        // console.log(JSON.stringify(entity, null, 2))
        try {
          const response = await axios.post(`${server}/business/purchases`, {
            entity,
          })
          // console.log('response: ', response)
          addAlert({
            message: 'Compra cargada exitosamente',
            status: 'success',
          })
        } catch (err) {
          addAlert({
            message: 'Error al crear compra',
            status: 'error',
          })
        } finally {
          setConfirmModal(false)
          onFinish()
        }
        // dispatch(fetchAndSetItems())
        // resetAll()
      }
    } catch (error) {
      // console.log(error)
      addAlert({
        message: 'Error al cargar compra',
        status: 'error',
      })
    }
  }

  // const loadOptions: DataTabView[] = [{
  //   title: 'Cantidad',
  //   data: <LoadForm item={currentItem}
  //     onClose={() => setLoadItemModal(false)}
  //     loadMethod={loadMethod} />
  // }]

  return (
    <div className="grid grid-cols-12 gap-6 h-full">
      <input type="file" ref={inputSubmitFileRef} onChange={onSubmitImage} />
      <div className="col-span-7">
        {!provider ? (
          <div style={{ height: '100%' }}>
            <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl">
              Seleccionar Proveedor
            </h2>
            <div className="flex justify-between items-center">
              <>
                {searchProviderParams.length > 0 && (
                  <Button
                    type="outline"
                    classes="w-1/5 h-8 mt-5 mb-b mr-3"
                    htmlType="button"
                    icon={<MdDelete size="24px" />}
                    onClick={() => clearDealerFilter()}
                  >
                    Limpiar Filtro
                  </Button>
                )}
                {/* <Button
                    type="outline"
                    classes="w-full h-8 mt-5 mb-b mr-3"
                    htmlType="button"
                    icon={<FiSearch />}
                    onClick={() => setSearchDealerModal(true)}
                  >
                    Buscar Proveedor
                  </Button> */}
                <Tooltip
                  // key={0}
                  title={
                    'Puede buscar por documento, correo, nombre y apellidos, nombre comercial o dirección fiscal'
                  }
                  position="bottom"
                  xOffset={0}
                  yOffset={0}
                  show={true}
                >
                  <div className="w-full h-8 mt-5 mr-3 rounded-md">
                    <div className="rounded-md bg-primaryGray-1200 rounded w-80 h-8 flex dark:bg-transparent dark:bg-gray-600 dark:border-gray-600">
                      <div className="flex items-center mx-3">
                        <FiSearch />
                      </div>
                      <div className="w-full h-full dark:bg-transparent bg-primaryGray-1200 rounded-md flex items-center">
                        <input
                          ref={ref}
                          // ref={headerActions.onSearch.ref}
                          className="dark:bg-gray-600 dark:border-gray-600 dark:text-white bg-primaryGray-1200 rounded border-transparent w-fullh-full input-advanced"
                          placeholder="Buscar. Ej: J88888888"
                          onChange={searchDealer}
                        />
                      </div>
                    </div>
                  </div>
                </Tooltip>
                <Button
                  icon={<IoAddOutline />}
                  type="primary"
                  classes="w-48 h-8 mt-5"
                  htmlType="button"
                  onClick={() => {
                    onCreateProvider()
                    // setCreateProviderModal(true)
                  }}
                >
                  Añadir Proveedor
                </Button>
              </>
            </div>
            <div className="mt-10">
              {/* <h2 className="mb-3 ml-5 text-primary dark:text-white font-bold text-3xl">
                  {dealers.length === 0
                    ? 'No se encontraron proveedores'
                    : searchProviderParams.length > 0
                    ? 'Resultado de búsqueda de Proveedores'
                    : 'Proveedores Frecuentes'}
                </h2> */}
              {dealers?.length > 0 ? (
                <div className="overflow-x-scroll h-72">
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <Table
                      // getOrderKeys={getOrderKeys}
                      data={dealers}
                      columns={dealersColumns}
                      showPagination={false}
                      onPressButton={(provider) => {
                        setSearchProviderParams([])
                        setProviderAndHasData(provider)
                      }}
                      // loading={loading}
                      // pageSelected={currentDealerPage}
                      // setPageSelected={setCurrentDealerPage}
                      // pages={numberOfPages}
                    />
                  </motion.div>
                </div>
              ) : (
                <div className="h-72">
                  <Empty
                    animationProps={{
                      animation: ProviderAnimation,
                      width: 100,
                      height: 100,
                    }}
                  >
                    <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                      Busque o registre un proveedor para realizar una carga por
                      factura
                    </p>
                  </Empty>
                </div>
              )}
            </div>
          </div>
        ) : !warehouse ? (
          <div style={{ height: '100%' }}>
            <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl mb-5">
              Almacén de Destino
            </h2>
            <label
              htmlFor="source"
              className="text-primary-900 dark:text-white"
            ></label>
            <input
              type="text"
              className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
              name="source"
              value={searchWarehouse}
              onChange={(e) => {
                setSearchWarehouse(e.target.value)
              }}
              onFocus={() => {
                setShowWarehouses(true)
              }}
              autoComplete="off"
            />
            <div className="overflow-x-scroll  h-80">
              <ShowLocations
                showLocations={showWarehouses}
                filterText={searchWarehouse}
                setShowLocations={setShowWarehouses}
                setSearchLocation={setSearchWarehouse}
                locations={warehouses}
                setLocation={setWarehouse}
                notToShow={null}
              ></ShowLocations>
            </div>
          </div>
        ) : !itemsToPurchaseRight.length ? (
          <div style={{ height: '100%' }}>
            <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl">
              Seleccionar Artículo
            </h2>
            {/* <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl">
                Seleccionar Proveedor
              </h2> */}
            <div className="flex items-center justify-between mt-3">
              <>
                <div className="mt-2">
                  <Datepicker
                    label="Seleccione la fecha de compra"
                    onChangeDate={async (date) => {
                      changePurchaseDate(date)
                      let dateFormat = dateToDB(date)
                      let response = await axios.get<{
                        rate: { rate: string }
                      }>(
                        `${server}/finances/rate?date=${dateFormat}&currency=1`
                      )
                      // console.log("response...", response.data.rate.rate)
                      setGlobalRate(response.data.rate.rate)
                      // console.log("date...", dateFormat)
                      setPurchaseDate(dateFormat)
                    }}
                  />
                </div>

                <div className="flex flex-row mt-5">
                  <Button
                    type="outline"
                    classes="h-8 mb-b mr-3 rounded-sm"
                    htmlType="button"
                    // icon={<FiSearch />}
                    onClick={() => {
                      onCreateItem()
                      // setCreateItemModal(true)
                    }}
                  >
                    Crear
                  </Button>
                  <Button
                    type="primary"
                    classes="h-8 rounded-sm"
                    htmlType="button"
                    onClick={() => setShowAddItemModal(true)}
                  >
                    Añadir
                  </Button>
                </div>
              </>
            </div>
            <div className="mt-10" style={{ height: '75%' }}>
              {/* <h3 className="mb-3 ml-5 text-primary-900 dark:text-white">
                  {items.length === 0
                    ? 'No se encontraron artículos'
                    : searchItemParams.length > 0
                    ? 'Resultado de búsqueda de artículos'
                    : 'Artículos recientes'}
                </h3> */}
              {itemsToPurchase.length > 0 ? (
                <div className="overflow-x-scroll" style={{ height: '100%' }}>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    style={{ maxHeight: '20vh', overflow: 'auto' }}
                  >
                    <Table
                      // getOrderKeys={getOrderKeys}
                      data={itemsToPurchase}
                      columns={itemsColumns}
                      showPagination={false}
                      // onPressButton={(item) => onPressRowItem(item)}
                      // loading={loading}
                      // pageSelected={currentDealerPage}
                      // setPageSelected={setCurrentDealerPage}
                      // pages={numberOfPages}
                    />
                  </motion.div>
                  <div className="flex flex-col items-end mt-4">
                    <div>
                      <div className="flex flex-row mb-2">
                        <h1 className="text-sm mr-2 text-primary">
                          Sub Total:
                        </h1>
                        <h1 className="text-sm">
                          Bs. {formatPipe(calcValues('SUBTOTAL'))}
                        </h1>
                      </div>
                      <div className="flex flex-row mb-2 items-center">
                        <Switch
                          forForm={true}
                          onChange={(v) => {
                            if (v) {
                              // discountInput.current?.focus()
                            } else {
                              setDiscountInput('0')
                              // if (discountInput && discountInput.current) {
                              // discountInput.current.value = '0'
                              // }
                              useDiscountRef.current.value = '0'
                            }
                            // console.log('V...', v)
                            setDiscountEditMode(v)
                          }}
                        />
                        <h1 className="text-sm mr-2 text-primary">
                          Descuento:
                        </h1>
                        {/* <InputText
                        disableInput={!discountEditMode}
                        defaultValue={'0'}
                        containerClasses="w-10"
                        
                      /> */}
                        <div style={{ width: 70 }}>
                          <input
                            type="text"
                            className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                            disabled={!discountEditMode}
                            ref={useDiscountRef}
                            value={useDiscountRef?.current?.value}
                            defaultValue="0"
                            // value={discountInput}
                            // onChange={(e) => setDiscountInput(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="flex flex-row mb-2 items-center">
                        <Switch
                          forForm={true}
                          onChange={(v) => {
                            if (v) {
                              // discountInput.current?.focus()
                            } else {
                              setIgtfInput('0')
                              // if (discountInput && discountInput.current) {
                              // discountInput.current.value = '0'
                              // }
                              igtfRef.current.value = '0'
                            }
                            // console.log('V...', v)
                            setIgtfEditMode(v)
                          }}
                        />
                        <h1 className="text-sm mr-2 text-primary">Igtf:</h1>
                        {/* <InputText
                        disableInput={!discountEditMode}
                        defaultValue={'0'}
                        containerClasses="w-10"
                        
                      /> */}
                        <div style={{ width: 70 }}>
                          <input
                            type="text"
                            className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                            disabled={!igtfEditMode}
                            ref={igtfRef}
                            value={igtfRef?.current?.value}
                            defaultValue="0"
                            // value={discountInput}
                            // onChange={(e) => setDiscountInput(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="flex flex-row mb-2">
                        <h1 className="text-sm mr-2 text-primary">IVA:</h1>
                        <h1 className="text-sm">
                          Bs. {formatPipe(calcValues('IVA'))}
                        </h1>
                      </div>
                      {/* <div className="flex flex-row mb-2 items-center">
                      <Switch
                        forForm={true}
                        onChange={(v) => {
                          if (!v) {
                            setIgtfInput('0')
                          }
                          setIgtfEditMode(v)
                        }}
                      />
                      <h1 className="text-sm mr-2 text-primary">IGTF:</h1>
                      <div className="w-12">
                        <input
                          type="text"
                          className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                          disabled={!igtfEditMode}
                          value={igtfInput}
                          onChange={(e) => setIgtfInput(e.target.value)}
                        />
                      </div>
                    </div> */}
                      <div className="flex flex-row mb-2">
                        <h1 className="text-base mr-2 text-primary">Total:</h1>
                        <h1 className="text-base">
                          Bs. {formatPipe(calcValues('TOTAL'))}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <Empty
                  animationProps={{
                    animation: ProviderAnimation,
                    width: 350,
                    height: 200,
                  }}
                >
                  <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                    Añada artículos para poder visualizarlos.
                  </p>
                </Empty>
              )}
            </div>
          </div>
        ) : !isLastPage ? (
          <div style={{ height: '100%' }}>
            <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl">
              Tipo de pago
            </h2>

            <h2 className="ml-5 text-primary dark:text-white font-bold text-2xl mt-5">
              {selectedPaymentType.text}
            </h2>

            <div className="flex flex-row items-center mt-2">
              <Select
                label="Selecciona forma de pago"
                defaultValue={paymentType[0]}
                options={paymentType}
                setSelectedHelper={(value) => {
                  setCashForm(null)
                  setCreditForm({
                    finalDate: `${today.day}/${today.month}/${today.year}`,
                  })
                  setSelectedPaymentType(value)
                  // setPayments([])
                }}
              />

              {selectedPaymentType.value === 1 && (
                <>
                  {/* // <Tooltip title="Agregar un pago nuevo"> */}
                  <div
                    className="flex justify-center	items-center rounded-md mt-3 cursor-pointer ml-5"
                    style={{
                      background: '#006AEA',
                      height: 34,
                      width: '140px',
                    }}
                    // onClick={async () => {

                    //   let date1 = `${today.year}-${+today.month < 10 ? `0${today.month}` : today.month}-${+today.day < 10 ? `0${today.day}` : today.day}`
                    //   // console.log("date1", date1)
                    //   // console.log("selected account date", selectedAccount.date)
                    //   const [day, month, year] = selectedAccount?.date.split("/")
                    //   let date2 = new Date(year, month-1, day).toISOString().replace(/T.+/, "")
                    //   // console.log("date2", date2)
                    //   let d1 = DateTime.fromISO(date1)
                    //   let d2 = DateTime.fromISO(date2)
                    //   // console.log("date1", d1)
                    //   // console.log("date2", d2)
                    //   if (d2 > d1) {
                    //     addAlert({
                    //       message: 'La fecha de pago no puede ser mayor a la fecha de compra',
                    //       status: 'error',
                    //     })
                    //   } else {
                    //     // console.log('selected', selectedAccount)
                    //     if (selectedAccount.account.currency !== '2') {
                    //       let response = await axios.get(
                    //         `${server}/finances/rate?date=${dateToDB(
                    //           selectedAccount.date
                    //         )}&currency=${selectedAccount.account.currency}`
                    //       )
                    //       const { rate } = response.data
                    //       // console.log("rate", rate)
                    //       setPayments((prevState) => [
                    //         ...prevState,
                    //         {
                    //           ...selectedAccount,
                    //           amount: toFixed(+selectedAccount?.amount || 0, 2),
                    //           rate: rate.rate,
                    //         },
                    //       ])
                    //     } else {
                    //       setPayments((prevState) => [
                    //         ...prevState,
                    //         {
                    //           ...selectedAccount,
                    //           amount: toFixed((+selectedAccount.amount || 0), 2),
                    //           rate: "1",
                    //         },
                    //       ])
                    //     }
                    //     setSelectedAccount({
                    //       reference: '',
                    //       amount: '',
                    //       account: {
                    //         ...accounts[0],
                    //         currency: accountsGlobal[0].idCurrency,
                    //       },
                    //       date: `${today.day}/${today.month}/${today.year}`,
                    //     })
                    //     let element = document.getElementById('input-amount') as HTMLElement
                    //     //@ts-ignore
                    //     element.value = ''
                    //   }
                    // }}
                    onClick={() => {
                      // setShowAddPaymentModal(true)
                      onShowAddPayment()
                    }}
                  >
                    <IoMdAdd className="text-white" />
                    <label className="text-white text-xs cursor-pointer">
                      Añadir Pago
                    </label>
                  </div>

                  {/* // </Tooltip> */}

                  {/* // <Tooltip title="Agregar un pago nuevo"> */}
                  <div
                    className="flex justify-center	items-center rounded-md mt-3 cursor-pointer ml-5"
                    style={{
                      background: '#006AEA',
                      height: 34,
                      width: '140px',
                    }}
                    // onClick={async () => {

                    //   let date1 = `${today.year}-${+today.month < 10 ? `0${today.month}` : today.month}-${+today.day < 10 ? `0${today.day}` : today.day}`
                    //   // console.log("date1", date1)
                    //   // console.log("selected account date", selectedAccount.date)
                    //   const [day, month, year] = selectedAccount?.date.split("/")
                    //   let date2 = new Date(year, month-1, day).toISOString().replace(/T.+/, "")
                    //   // console.log("date2", date2)
                    //   let d1 = DateTime.fromISO(date1)
                    //   let d2 = DateTime.fromISO(date2)
                    //   // console.log("date1", d1)
                    //   // console.log("date2", d2)
                    //   if (d2 > d1) {
                    //     addAlert({
                    //       message: 'La fecha de pago no puede ser mayor a la fecha de compra',
                    //       status: 'error',
                    //     })
                    //   } else {
                    //     // console.log('selected', selectedAccount)
                    //     if (selectedAccount.account.currency !== '2') {
                    //       let response = await axios.get(
                    //         `${server}/finances/rate?date=${dateToDB(
                    //           selectedAccount.date
                    //         )}&currency=${selectedAccount.account.currency}`
                    //       )
                    //       const { rate } = response.data
                    //       // console.log("rate", rate)
                    //       setPayments((prevState) => [
                    //         ...prevState,
                    //         {
                    //           ...selectedAccount,
                    //           amount: toFixed(+selectedAccount?.amount || 0, 2),
                    //           rate: rate.rate,
                    //         },
                    //       ])
                    //     } else {
                    //       setPayments((prevState) => [
                    //         ...prevState,
                    //         {
                    //           ...selectedAccount,
                    //           amount: toFixed((+selectedAccount.amount || 0), 2),
                    //           rate: "1",
                    //         },
                    //       ])
                    //     }
                    //     setSelectedAccount({
                    //       reference: '',
                    //       amount: '',
                    //       account: {
                    //         ...accounts[0],
                    //         currency: accountsGlobal[0].idCurrency,
                    //       },
                    //       date: `${today.day}/${today.month}/${today.year}`,
                    //     })
                    //     let element = document.getElementById('input-amount') as HTMLElement
                    //     //@ts-ignore
                    //     element.value = ''
                    //   }
                    // }}
                    onClick={() => {
                      // setShowAddPaymentModal(true)
                      onShowAddWithholding()
                    }}
                  >
                    <IoMdAdd className="text-white" />
                    <label className="text-white text-xs cursor-pointer">
                      Añadir Retención IVA
                    </label>
                  </div>

                  <div
                    className="flex justify-center	items-center rounded-md mt-3 cursor-pointer ml-5"
                    style={{
                      background: '#006AEA',
                      height: 34,
                      width: '160px',
                    }}
                    onClick={() => {
                      onShowAddWithholdingISLR()
                    }}
                  >
                    <IoMdAdd className="text-white" />
                    <label className="text-white text-xs cursor-pointer">
                      Añadir Retención ISLR
                    </label>
                  </div>

                  {/* // </Tooltip> */}
                </>
              )}
            </div>

            {selectedPaymentType.value === 1 && (
              <div
                className="mt-5"
                style={{ maxHeight: '25vh', overflow: 'auto' }}
              >
                <Table
                  // getOrderKeys={getOrderKeys}
                  data={payments}
                  columns={paymentsColumns}
                  showPagination={false}
                  onPressButton={(item) => {
                    setEditItemToLoadModal(true)
                    setEditingItem(item)
                    setBaseEditingItem(
                      items.find((i) => i.id === item.id) || null
                    )
                  }}
                  // loading={loading}
                  // pageSelected={currentDealerPage}
                  // setPageSelected={setCurrentDealerPage}
                  // pages={numberOfPages}
                />
              </div>
            )}

            {selectedPaymentType.value === 1 && (
              <div className="flex flex-row justify-between mt-[20px]">
                <div className="flex flex-row items-end pb-[10px]">
                  <h1 className="text-sm mr-2 text-primary">
                    Total pagos (y ret.):
                  </h1>
                  <h1 className="text-sm">
                    Bs. {formatPipeTotal(getTotalPayments)}
                  </h1>
                </div>
              </div>
            )}

            {/* {selectedPaymentType.value === 1 && (
              <div className="grid grid-cols-12 gap-x-4 mt-3">
                <div className="col-span-3 mt-2">
                  <Select
                    value={selectedAccount?.account}
                    options={accounts}
                    label="Cuenta"
                    onChange={(values) => {
                      
                      let currency = accountsGlobal.find(
                        (v) => v?.id === values?.value
                      )?.idCurrency
                      if (values) {
                        values.currency = currency
                      }
                      setSelectedAccount((prevState) => ({
                        ...prevState,
                        account: values,
                      }))
                    }}
                  />
                </div>

                <div className="col-span-3">
                  <label className="font-medium text-primary-900 text-xs dark:text-white">
                    Monto
                  </label>
                  <input
                    id='input-amount'
                    type="text"
                    className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                    name="amount"
                    
                    autoComplete="off"
                  />
                </div>

                <div className="col-span-3 mt-3">
                  <Datepicker
                    topPosition={-120}
                    label="Fecha"
                    defaultValue={selectedAccount?.date}
                    onChangeDate={(date) => {
                      setSelectedAccount((prevState) => ({
                        ...prevState,
                        date,
                      }))
                    }}
                  />
                </div>

                <div className="col-span-3">
                  <label className="font-medium text-primary-900 text-xs dark:text-white">
                    Referencia
                  </label>
                  <input
                    type="text"
                    className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                    name="amount"
                    value={selectedAccount?.reference}
                    onChange={(e) => {
                      setSelectedAccount((prevState) => ({
                        ...prevState,
                        reference: e.target.value,
                      }))
                    }}
                    autoComplete="off"
                  />
                </div>
              </div>
            )} */}

            {selectedPaymentType.value === 2 && (
              <div className="grid grid-cols-12 gap-x-6">
                <div className="col-span-6">
                  {/* <Select
                    label="Cantidad de pagos"
                    options={[
                      { text: '5', value: 1 },
                      { text: '10', value: 2 },
                    ]}
                    defaultValue={{ text: '5', value: 1 }}
                    onChange={(value) => {
                      setCreditForm((prevState) => ({
                        ...prevState,
                        payments : value?.text,
                      }))                    
                    }}
                  /> */}
                  <label className="font-medium text-primary-900 text-xs dark:text-white">
                    Cantidad de pagos
                  </label>
                  <input
                    type="number"
                    className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                    name="account"
                    value={creditForm?.installmentQuantity}
                    onChange={(e) => {
                      let [day, month, year] = (
                        creditForm?.date ||
                        `${today.day}/${today.month}/${today.year}`
                      )?.split('/')
                      let days =
                        (+e.target.value || 0) *
                        (+creditForm?.installmentRange || 0)
                      let finalDate = DateTime.local(+year, +month, +day)
                        .setLocale('es')
                        .plus({
                          days,
                        })
                      setCreditForm((prevState) => ({
                        ...prevState,
                        installmentQuantity: e.target.value,
                        finalDate: finalDate.toLocaleString(),
                      }))
                    }}
                    autoComplete="off"
                    min="0"
                  />
                </div>

                <div className="col-span-6 row-start-2">
                  {/* <Select label="Plazo entre pagos" options={[
                      { text: '5', value: 1 },
                      { text: '10', value: 2 },
                    ]} onChange={(value) => {
                      setCreditForm((prevState) => ({
                        ...prevState,
                        timeBetween : value?.text,
                      }))
                    }}
                    defaultValue={{ text: '5', value: 1 }}
                    /> */}

                  <label className="font-medium text-primary-900 text-xs dark:text-white">
                    Plazo entre pagos (en días)
                  </label>
                  <input
                    type="number"
                    className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                    name="account"
                    min="0"
                    value={creditForm?.installmentRange}
                    onChange={(e) => {
                      let [day, month, year] = (
                        creditForm?.date ||
                        `${today.day}/${today.month}/${today.year}`
                      )?.split('/')
                      let days =
                        (+e.target.value || 0) *
                        (+creditForm?.installmentQuantity || 0)
                      let finalDate = DateTime.local(+year, +month, +day)
                        .setLocale('es')
                        .plus({
                          days: days,
                        })

                      setCreditForm((prevState) => ({
                        ...prevState,
                        installmentRange: e.target.value,
                        finalDate: finalDate.toLocaleString(),
                      }))
                    }}
                    autoComplete="off"
                  />
                </div>

                <div className="col-span-6 row-start-2 flex flex-row justify-around items-center">
                  <h3>Fecha final:</h3>
                  <h3>{creditForm?.finalDate}</h3>
                </div>

                <div className="col-span-6 mt-3">
                  <Datepicker
                    label="Fecha inicial de pago"
                    onChangeDate={(date) => {
                      let [day, month, year] = (
                        date || `${today.day}/${today.month}/${today.year}`
                      )?.split('/')
                      let days =
                        (+creditForm?.installmentQuantity || 0) *
                        (+creditForm?.installmentRange || 0)
                      let finalDate = DateTime.local(+year, +month, +day)
                        .setLocale('es')
                        .plus({
                          days,
                        })

                      setCreditForm((prevState) => ({
                        ...prevState,

                        date,
                        finalDate: finalDate.toLocaleString(),
                      }))
                    }}
                  />
                </div>

                <div className="col-span-6 mt-6">
                  <div className="flex flex-row mb-3">
                    <label className="font-medium text-primary-900 text-xs dark:text-white">
                      Indexar deuda
                    </label>
                    <Tooltip
                      xOffset={20}
                      title="La deuda se guardará referencialmente en USD y se reajustará automáticamente a la tasa de cambio"
                    >
                      <GrCircleInformation
                        size={12}
                        className="ml-3"
                        style={{ marginTop: -5 }}
                      />
                    </Tooltip>
                  </div>
                  <Switch
                    value={indexDebt}
                    forForm={true}
                    onChange={(v) => setIndexDebt(v)}
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <h2 className="ml-5 text-primary dark:text-white font-bold text-3xl">
              Datos de la factura
            </h2>

            <div className="grid grid-cols-12 gap-10 mt-5">
              <div className="col-span-6">
                <label className="font-medium text-primary-900 text-xs dark:text-white">
                  Número de factura
                </label>
                <input
                  type="text"
                  className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                  name="account"
                  value={bill?.code}
                  onChange={(e) => {
                    setBill((prevState) => ({
                      ...prevState,
                      code: e.target.value,
                    }))
                  }}
                  autoComplete="off"
                />
              </div>

              <div className="col-span-6">
                <label className="font-medium text-primary-900 text-xs dark:text-white">
                  Número de documento
                </label>
                <input
                  type="text"
                  className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
                  name="account"
                  value={bill?.control}
                  onChange={(e) => {
                    setBill((prevState) => ({
                      ...prevState,
                      control: e.target.value,
                    }))
                  }}
                  autoComplete="off"
                />
              </div>

              <div className="col-span-6">
                <Datepicker
                  label="Fecha de creación"
                  onChangeDate={(date) => {
                    setBill((prevState) => ({
                      ...prevState,
                      emissionDate: date,
                    }))
                  }}
                />
              </div>

              {/* <div className="col-span-6">
                <Datepicker
                  label="Fecha de expiración"
                  onChangeDate={(date) => console.log('date', date)}
                />
              </div> */}

              {/* <div className="col-span-6">
                <Datepicker
                  label="Fecha del libro"
                  onChangeDate={(date) => console.log('date', date)}
                />
              </div> */}

              <div className="col-span-6">
                <label className="font-medium text-primary-900 text-xs dark:text-white">
                  Notas
                </label>
                <textarea
                  className="dark:bg-gray-600 dark:border-gray-600 dark:text-white"
                  value={bill?.description}
                  onChange={(e) => {
                    setBill((prevState) => ({
                      ...prevState,
                      description: e.target.value,
                    }))
                  }}
                  placeholder="Notas adicionales de las notas de entrega."
                  style={{ resize: 'none' }}
                />
              </div>

              <div className="flex flex-row col-span-12 justify-end my-2">
                <IoMdAdd className="text-primary" />
                <u
                  className="text-xs text-primary cursor-pointer"
                  onClick={() =>
                    inputSubmitFileRef.current &&
                    inputSubmitFileRef.current.click()
                  }
                  style={{ color: '#006AEA', cursor: 'pointer' }}
                >
                  Subir documento
                </u>
              </div>
            </div>
          </div>
        )}
        {/* <div className=" h-40 mt-2 p-4 ">
            {!purchaseNote ? (
              <div className="flex flex-row justify-between">
                <h2>Datos de Factura</h2>
                <Button
                  type="primary"
                  classes="w-1/2 h-8"
                  htmlType="button"
                  onClick={() => setPurchaseNoteModal(true)}
                >
                  Agregar Factura
                </Button>
              </div>
            ) : (
              <div className="flex flex-row justify-between">
                <div>
                  <p>Fecha de Creación: {purchaseNote.emisionDate}</p>
                  <p>Fecha de Expiración: {purchaseNote.expirationDate}</p>
                  <p>Fecha de Libro: {purchaseNote.bookDate}</p>
                  <p>Código de document: {purchaseNote.serial}</p>
                  <p>Notas: {purchaseNote.notes || 'Sin notas adicionales'}</p>
                </div>
                <button
                  className="mr-4 mt-4 border-none"
                  onClick={() => {
                    setEditingLoadNote(purchaseNote)
                    setPurchaseNoteModal(true)
                  }}
                >
                  <HiOutlinePencil size={20} className="text-primary" />
                </button>
              </div>
            )}
            <div>
              Costo Total: {` ${total} Bs`}
              {itemsToPurchase.reduce(
                (acc, i) =>
                  acc + (Number(i?.cost) || 0) * Number(i.quantity),
                0
              )}
            </div>
          </div> */}
      </div>

      <div className="col-span-5 flex flex-col justify-between lg:overflow-auto">
        <div>
          <div className="mt-5 flex xl:flex-row lg:flex-col justify-between">
            <div
              style={{ width: windowSize.innerWidth < 1400 ? '100%' : '48%' }}
            >
              {provider ? (
                <>
                  {/* <h3 className="mb-3 ml-5 text-primary-900 dark:text-white">
                    Datos de Proveedor
                  </h3> */}
                  {/* {console.log('provider: ', provider)} */}
                  <div className="dark:bg-black bg-primaryGray-1300 rounded-xl p-3 h-48">
                    <div>
                      <IoDocumentAttachSharp className="text-primary mb-2" />
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Razón Social:</p>
                        <p className="truncate">{provider?.businessName}</p>
                      </div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Nombre Comercial:</p>
                        <p className="truncate">{provider?.commercialName}</p>
                      </div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Documento:</p>
                        <p className="truncate">
                          {provider?.document.documentType}-
                          {provider?.document.document}
                        </p>
                      </div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Dirección Fiscal:</p>
                        <p className="truncate">
                          {provider?.address.fiscalAddress}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        className="flex mt-1 border-none"
                        onClick={() => setProviderAndHasData(null)}
                      >
                        <FiTrash2 size={20} className="text-primary" />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="mt-5 m-auto">Proveedor no seleccionado</div>
              )}
            </div>
            <div
              style={{
                width: windowSize.innerWidth < 1400 ? '100%' : '48%',
                marginTop: windowSize.innerWidth < 1400 ? '20px' : '',
              }}
            >
              {warehouse ? (
                <>
                  {/* <h3 className="mb-3 ml-5 text-primary-900 dark:text-white">
                    Datos de Almacén
                  </h3> */}
                  <div className="dark:bg-black bg-primaryGray-1300 rounded-xl p-3 h-48 flex flex-col justify-between">
                    <div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Almacén:</p>
                        <p className="truncate">{warehouse?.name}</p>
                      </div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Descripción:</p>
                        <p className="truncate">{warehouse?.description}</p>
                      </div>
                      <div className="flex mb-2">
                        <p className="font-bold mr-1">Existencias:</p>
                        <p className="truncate">
                          {warehouse?.numberOfExistences}
                        </p>
                      </div>

                      {/* <p>Existencias: {warehouse?.numberOfExistences}</p> */}
                    </div>
                    <div className="flex justify-end">
                      <button
                        className="flex mt-1 border-none"
                        onClick={() => {
                          setWarehouse(null)
                          setSearchWarehouse('')
                        }}
                      >
                        <FiTrash2 size={20} className="text-primary" />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="mt-5">Almacén no seleccionado</div>
              )}
            </div>
          </div>

          {itemsToPurchaseRight.length ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              {/* <h3 className="mb-3 ml-5 text-primary-900 dark:text-white mt-5 ">
                Artículos para cargar
              </h3> */}
              <div className="overflow-auto h-full mt-5">
                <Table
                  // getOrderKeys={getOrderKeys}
                  data={itemsToPurchaseRight}
                  columns={itemsColumns.slice(0, -1)}
                  showPagination={false}
                  onPressButton={(item) => {
                    setEditItemToLoadModal(true)
                    setEditingItem(item)
                    setBaseEditingItem(
                      items.find((i) => i.id === item.id) || null
                    )
                  }}
                  // loading={loading}
                  // pageSelected={currentDealerPage}
                  // setPageSelected={setCurrentDealerPage}
                  // pages={numberOfPages}
                />
              </div>
              <h1 className="mt-2 text-base text-right">{`Total: Bs. ${formatPipe(
                calcValues('TOTAL')
              )}`}</h1>
            </motion.div>
          ) : (
            <div className="mt-5 m-auto">No hay artículos por cargar</div>
          )}
        </div>

        <div className="flex flex-col items-end">
          <div className="flex flex-row mr-5">
            {[...new Array(5)].map((_, i) => (
              <div
                key={i}
                className="mr-1"
                style={{
                  width: 15,
                  height: 15,
                  backgroundColor: getCurrentPageColor(i),
                  borderRadius: 20,
                }}
              ></div>
            ))}
          </div>

          <div className="flex flex-row mt-2">
            <div
              className="flex flex-row mr-5 items-center"
              onClick={() => goBack()}
            >
              <MdArrowBackIosNew className="mr-2" />
              <div className="cursor-pointer">Atrás</div>
            </div>

            <div
              className="flex flex-row items-center"
              onClick={() => (isLastPage ? finishPurchase() : goForward())}
            >
              <div className="text-primary cursor-pointer">
                {isLastPage ? 'Finalizar Compra' : 'Siguiente'}
              </div>
              <MdArrowForwardIos className="ml-2" />
            </div>
          </div>
        </div>
      </div>
      {/* {searchDealerModal && (
        <Modal
          display={searchDealerModal}
          // modalClasses="w-2/5 py-4 px-8"
          scroll="visible"
          onAccept={() => null}
          onClose={() => {
            setSearchDealerModal(false)
          }}
        >
          <SearchDealersForm
            setSearchModal={setSearchDealerModal}
            setLoading={setLoading}
            setSearchParams={setSearchProviderParams}
            currentPage={currentDealerPage}
            setCurrentPage={setCurrentDealerPage}
          />
        </Modal>
      )} */}

      {createProviderModal && (
        <Modal
          display={createProviderModal}
          // modalClasses="w-2/5 py-4 px-8"
          scroll="scroll"
          onAccept={() => null}
          onClose={() => {
            setCreateProviderModal(false)
          }}
        >
          <DealersForm
            onSubmit={createDealerMethod}
            onCancel={() => setCreateProviderModal(false)}
          />
        </Modal>
      )}

      {searchItemModal && (
        <ModalInventorySearch
          modalSearch={searchItemModal}
          onCloseModalSearch={() => setSearchItemModal(false)}
          onSubmitInventory={searchItem}
        />
      )}

      {loadItemModal && currentItem && (
        <Modal
          display={loadItemModal}
          // modalClasses="w-2/5 py-4 px-8"
          scroll="scroll"
          onAccept={() => null}
          onClose={() => {
            setLoadItemModal(false)
          }}
        >
          {/* <LoadForm
            item={currentItem}
            onClose={() => setLoadItemModal(false)}
            loadMethod={loadMethod}
          /> */}
          <StepForm
            item={currentItem}
            onClose={() => setLoadItemModal(false)}
            loadMethod={bigLoadMethod}
          />
        </Modal>
      )}

      {editItemToLoadModal && baseEditingItem && (
        <Modal
          display={editItemToLoadModal}
          // modalClasses="w-2/5 py-4 px-8"
          scroll="visible"
          onAccept={() => null}
          onClose={() => {
            setEditItemToLoadModal(false)
          }}
        >
          {/* <EditItemToLoadForm
            item={editingItem}
            onClose={() => {
              setEditItemToLoadModal(false)
              setEditingLoadNote(null)
            }}
            loadMethod={updateMethod}
          /> */}
          <StepForm
            onClose={() => setEditItemToLoadModal(false)}
            loadMethod={updateMethod}
            item={baseEditingItem}
            itemToPurchase={editingItem}
          />
        </Modal>
      )}

      {resetModal && (
        <ModalConfirm
          title="¿Desea reiniciar todo el proceso?"
          displayConfirmModal={resetModal}
          onCancel={() => setResetModal(false)}
          onConfirm={() => resetAll()}
          // modalClasses='"w-2/5 py-4 px-8'
        />
      )}

      {purchaseNoteModal && (
        <Modal
          display={purchaseNoteModal}
          // modalClasses="w-2/5 py-4 px-8"
          scroll="scroll"
          onAccept={() => null}
          onClose={() => {
            setPurchaseNoteModal(false)
          }}
        >
          <PurchaseNoteForm
            onClose={() => setPurchaseNoteModal(false)}
            setPurchaseNote={(value) => {
              addAlert({
                message: 'Factura agregada',
                status: 'success',
              })
              setPurchaseNote(value)
            }}
            editingLoadNote={editingLoadNote}
          />
        </Modal>
      )}

      {createItemModal && (
        <Modal
          display={createItemModal}
          scroll="visible"
          onAccept={() => null}
          onClose={() => {
            setCreateItemModal(false)
          }}
        >
          <InventoryForm
            submitting={loading}
            categoriesValues={categoriesValues}
            onSubmit={createItemMethod}
            onClose={() => setCreateItemModal(false)}
            units={units.map((unit) => ({ value: unit.id, text: unit.name }))}
            categories={categories}
          />
        </Modal>
      )}

      {associatedCodeModal && itemToModify && (
        <Modal
          display={associatedCodeModal}
          onClose={() => {
            setAssociatedCodeModal(false)
            setItemToModify(null)
          }}
          onAccept={() => null}
          // modalClasses="w-2/6 py-4 px-12"
        >
          {/* <AssociatedCode items={items} edit={itemToModify} willErase={false} /> */}
        </Modal>
      )}

      {editCostsModal && itemToModify && (
        <Modal
          display={editCostsModal}
          scroll="scroll"
          onClose={() => {
            setEditCostsModal(false)
            setItemToModify(null)
          }}
          // modalClasses="w-3/6 py-4 px-12 min-w-min"
        >
          <CostForm
            cost={
              itemToModify?.cost?.length > 0
                ? itemToModify?.cost[0]?.amount
                : '0.00'
            }
            price={
              itemToModify?.price?.length > 0
                ? itemToModify.price[0]?.amount
                : '0.00'
            }
            excent={itemToModify?.exempt}
            id_selected={itemToModify?.id}
            items={
              itemToModify?.type === 'COMPOUND'
                ? itemToModify.composition
                : itemToModify.type === 'ASSEMBLY'
                ? itemToModify.assembly
                : []
            }
            name={itemToModify?.name && itemToModify.name}
            itemType={itemToModify?.type}
            onClose={() => {
              setEditCostsModal(false)
              setItemToModify(null)
            }}
            aditionalEffect={updatePriceMethod}
            // getItems={() => dispatch(fetchItemsCall())}
          ></CostForm>
        </Modal>
      )}

      <ModalConfirm
        title={'¿Está seguro que desea realizar esta compra?'}
        displayConfirmModal={confirmModal}
        onConfirm={() => createPurchase()}
        onCancel={() => setConfirmModal(false)}
        positive={true}
      ></ModalConfirm>

      {/* <Prompt
        when={
          provider !== null ||
          warehouse !== null ||
          loadNote !== null ||
          itemsToLoad.length !== 0
        }
        message="¿Está seguro que desea abandonar la carga de inventario?, el llenado actual de los campos se perderá"
      /> */}

      {/* <div className="grid grid-cols-2 gap-6 mt-5">
        <div className="flex px-1 mt-3 ">
          <Button
            danger={true}
            type="outline"
            // classes="w-1/2 mr-4 h-8"
            classes="w-1/2 h-8 flex-1"
            onClick={() => setResetModal(true)}
            htmlType="button"
            disabled={
              provider === null &&
              warehouse === null &&
              purchaseNote === null &&
              itemsToPurchase.length === 0
            }
          >
            Reiniciar
          </Button>
        </div>
        <div className="flex px-1 mt-3 ">
          <Button
            type="primary"
            classes="w-1/2 h-8 flex-1"
            htmlType="button"
            onClick={() => setConfirmModal(true)}
            disabled={
              !(
                provider !== null &&
                warehouse !== null &&
                purchaseNote !== null &&
                itemsToPurchase.length > 0
              )
            }
          >
            Cargar Inventario
          </Button>
        </div>
      </div> */}

      <Modal
        display={showAddItemModal}
        onClose={() => setShowAddItemModal(false)}
      >
        <AddItemToPurchaseForm
          onSubmit={(values) => {
            if (itemsToPurchase.some((v) => v.item.id === values.item.id)) {
              let items = itemsToPurchase.map((v) => {
                if (v.item.id === values.item.id) {
                  return {
                    ...v,
                    cost: +v.cost + +values.cost,
                    amount: +v.amount + +values.amount,
                    received: +v.received + +values.received,
                  }
                }
                return v
              })
              setItemsToPurchase(items)
            } else {
              setItemsToPurchase((prevState) => [...prevState, values])
            }
            setShowAddItemModal(false)
          }}
          onClose={() => setShowAddItemModal(false)}
          globalRate={globalRate}
        />
      </Modal>

      <Modal display={showModal} onClose={() => setshowModal(false)}>
        <h2 className="text-base text-primary">
          {`Tu pago supera en Bs.${surplusAmount} el costo de la compra 
          ¿Cómo deseas registrar el excedente del pago?"`}
        </h2>
        <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

        <div className="flex flex-row justify-around mt-5">
          <label
            className="cursor-pointer"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('RECEIVABLE')

              let withholding = paymentsProps.find(
                (v) => v.account.text === 'Retención IVA'
              )
              let withholdingISLR = paymentsProps.find(
                (v) => v.account.text === 'Retención ISLR'
              )

              try {
                console.log('body...')
                addAlert({
                  message: 'Creando compra...',
                  status: 'loading',
                })
                // let resp = await axios.post(`${server}/purchase`, body)

                let s3InfoResponse: { value: any } = { value: {} }

                if (document) {
                  await uploadToS3(
                    document,
                    s3InfoResponse,
                    `${userTenantId}/purchases/${uuidv4()}_${document?.name}`,
                    userTenantId,
                    docs_url
                  )
                }
                let resp = await axios.post(`${server}/purchase`, {
                  ...body,
                  bill: body?.bill
                    ? {
                        ...body?.bill,
                        document: document
                          ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                          : null,
                      }
                    : null,
                })

                if (withholding) {
                  const withholdingBody = {
                    amountWithheld: withholding?.amountWithheld,
                    withholdingPercentage: withholding?.withholdingPercentage,
                    taxBase: withholding?.taxBase,
                    excempt: withholding?.excempt,
                    voucherNumber: withholding?.voucherNumber || null,
                    taxRate: withholding?.taxRate,
                    taxTotal: withholding?.taxTotal,
                    id: resp?.data?.purchase?.id,
                  }

                  await axios.post(
                    `${server}/purchase/withholding`,
                    withholdingBody
                  )
                }

                if (withholdingISLR) {
                  const withholdingISLRBody = {
                    amountWithheld: withholdingISLR?.amountWithheld,
                    withholdingPercentage: withholdingISLR?.withholdingPercentage,
                    taxBase: withholdingISLR?.taxBase,
                    excempt: withholdingISLR?.excempt,
                    subtrahend: withholdingISLR?.subtrahend,
                    voucherNumber: withholdingISLR?.voucherNumber || null,
                    taxRate: withholdingISLR?.taxRate,
                    taxTotal: withholdingISLR?.taxTotal,
                    id: resp?.data?.purchase?.id,
                  }

                  await axios.post(
                    `${server}/purchase/islr-withholding`,
                    withholdingISLRBody
                  )
                }

                setPaymentsProps([])
                // setPayments([])
                addAlert({
                  message: 'Compra realizada con éxito',
                  status: 'success',
                })
                setshowModal(false)
                onFinish()
              } catch (err) {
                addAlert({
                  message: 'Error al crear compra',
                  status: 'error',
                })
              }
            }}
          >
            Registrar como deuda por cobrar al proveedor
          </label>
          <label
            className="cursor-pointer"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('ADVANCE')
              let withholding = paymentsProps.find(
                (v) => v.account.text === 'Retención IVA'
              )
              let withholdingISLR = paymentsProps.find(
                (v) => v.account.text === 'Retención ISLR'
              )

              try {
                addAlert({
                  message: 'Creando compra...',
                  status: 'loading',
                })

                let s3InfoResponse: { value: any } = { value: {} }

                if (document) {
                  await uploadToS3(
                    document,
                    s3InfoResponse,
                    `${userTenantId}/purchases/${uuidv4()}_${document?.name}`,
                    userTenantId,
                    docs_url
                  )
                }
                let resp = await axios.post(`${server}/purchase`, {
                  ...body,
                  bill: body?.bill
                    ? {
                        ...body?.bill,
                        document: document
                          ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                          : null,
                      }
                    : null,
                })

                if (withholding) {
                  const withholdingBody = {
                    amountWithheld: withholding?.amountWithheld,
                    withholdingPercentage: withholding?.withholdingPercentage,
                    taxBase: withholding?.taxBase,
                    excempt: withholding?.excempt,
                    voucherNumber: withholding?.voucherNumber,
                    taxRate: withholding?.taxRate,
                    taxTotal: withholding?.taxTotal,
                    id: resp?.data?.purchase?.id,
                  }

                  await axios.post(
                    `${server}/purchase/withholding`,
                    withholdingBody
                  )
                }

                if (withholdingISLR) {
                  const withholdingISLRBody = {
                    amountWithheld: withholdingISLR?.amountWithheld,
                    withholdingPercentage: withholdingISLR?.withholdingPercentage,
                    taxBase: withholdingISLR?.taxBase,
                    excempt: withholdingISLR?.excempt,
                    subtrahend: withholdingISLR?.subtrahend,
                    voucherNumber: withholdingISLR?.voucherNumber,
                    taxRate: withholdingISLR?.taxRate,
                    taxTotal: withholdingISLR?.taxTotal,
                    id: resp?.data?.purchase?.id,
                  }

                  await axios.post(
                    `${server}/purchase/islr-withholding`,
                    withholdingISLRBody
                  )
                }

                setPaymentsProps([])
                // setPayments([])
                addAlert({
                  message: 'Compra realizada con éxito',
                  status: 'success',
                })
                setshowModal(false)
                onFinish()
              } catch (err) {
                addAlert({
                  message: 'Error al crear compra',
                  status: 'error',
                })
              }
            }}
          >
            Registrar como anticipo al proveedor
          </label>
        </div>
      </Modal>
    </div>
  )
}

interface PurchaseProps {
  // setHasData: Dispatch<SetStateAction<boolean>>
  onFinish: Function
  onCreateProvider: Function
  defaultProvider?: any | null
  onShowAddPayment?: Function
  changePurchaseDate?: Function
  paymentsProps: any[]
  setPaymentsProps?: any
  onCreateItem: Function
  onShowAddWithholding?: Function
  onShowAddWithholdingISLR?: Function
  onItemsToPurchaseRightChange: Function
}

export default Purchase
